import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { connect } from "react-redux";
import { externals } from "../../config.json";
import CloseIcon from "@mui/icons-material/Close";
import {
  handleTreeChange,
  updateAthenaStorage,
  updateChangeLogs,
  updateDynamicOption_Done,
  updateStoreVals,
} from "../../redux/VR2/vr2Actions";

import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  Typography,
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableContainer as MuiTableContainer,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import { Box, styled } from "@mui/system";
import _ from "lodash";
import moment from "moment";
import {
  AiFillCheckSquare,
  AiFillClockCircle,
  AiFillCloseSquare,
} from "react-icons/ai";
import SearchIcon from "@mui/icons-material/Search";
import { ImFolderUpload } from "react-icons/im";
import { IoMdAddCircle, IoMdRemoveCircle } from "react-icons/io";
import Spinner from "../../components/BackDrop_Spinner";
import Popup from "../../components/SimplePOPUP";
import { postRequest } from "../../globalhelper/helper";

import { Tooltip } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import GetAppIcon from "@material-ui/icons/GetApp";
import { CSVLink } from "react-csv";
import globalhelper from "../../helper/globalhelper";
import CostContributionPopup from "../Edureka/CostContribution/CostContributionPopup";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Delete, Edit } from "@material-ui/icons";
import { showAlert } from "../../redux/Common/commonActions";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const dynamicApiCache = new Map();
class MyTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ROWNUM: null,
      DocumentStatus: null,
      EditRow: null,
      AllItemRef: [],
      downloadData: [],
      showSpinner: false,
      showPopUP: false,
      ask_reason: false,
      dynamicOption: [],
      BillExtract_theme_save: false,
      popup_table: false,
      open_popup_select: false,
      Give_Val_By_ServiceKey: {},
      ValidationError: {},
      apiExecution: {},
      //mbp
      isPopupOpen: false,
      Lob: [],
      dynamicValue: [],
      preFillValues: [],
      lastServiceIDSegment: "",
      // companyid:this.props.storeVals[`billworkflowinfo#organizationid`]
      companyid: this.props.ORG_ID_CONST,
      DialogData: null,
      token: this.props.screenName,
      billingSummaryLock: false, // 🔥 Prevent recursion
    };

    this.PO_IP_Item_Ref_Pattern_Match_Called = false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.time !== nextProps.time) {
      // Perform any logic you need to update your component state based on the new props
      this.setState({
        // Update the component's state as needed
        arvind: "python master",
      });
    }
  }

  componentDidMount() {
    typeof this.props?.setFnToCallonVendorIDonChange === "function" &&
      this.props?.setFnToCallonVendorIDonChange(this.functionToCall);
    let VR2_Form_Json = this.props.VR2_Form_Json;
    let found = false;
    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        if (each.processcode === "WF") {
          each.children.forEach((each2, j) => {
            if (found) return;
            if (each2.children && each2.children?.length) {
              each2.children.forEach((each3, k) => {
                if (found) return;

                if (
                  !each3.children &&
                  each3?.render &&
                  each3?.render === "true" &&
                  each3?.title === "Status"
                ) {
                  console.log(
                    each3,
                    !each3.children,
                    each3?.render,
                    each3?.render === "true",
                    each3.serviceID === "purchaseorderinfo#status",
                    "each3"
                  );

                  this.setState({ ...this.state, DocumentStatus: each3.val });
                  found = true;
                  if (found) return;
                }
              });
            }
          });
        }
      }
    });
    this.getLobOptions(); //mbp
    // this.getTotalvalue();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.ORG_ID_CONST !== this.props.ORG_ID_CONST) {
      this.setState(
        {
          companyid: this.props.ORG_ID_CONST,
        },
        () => {
          this.getLobOptions();
        }
      );
    }
  }

  // componentDidMount() {
  //   this.props?.setFnToCallonVendorIDonChange(this.functionToCall);

  //   this.getLobOPtions(); //mbp
  //   // this.getTotalvalue();
  // }

  Give_Val_By_ServiceKey = (serviceKey) => {
    console.log(serviceKey);

    let VR2_Form_Json = this.props.VR2_Form_Json;

    for (const each of VR2_Form_Json || []) {
      if (!each.children?.length) continue;

      for (const each2 of each.children) {
        if (!each2.children?.length) continue;

        for (const each3 of each2.children) {
          // Normal field
          if (
            !each3.children &&
            each3?.render === "true" &&
            each3.serviceKey === serviceKey
          ) {
            this.setState({
              Give_Val_By_ServiceKey: {
                ...this.state.Give_Val_By_ServiceKey,
                [serviceKey]: each3.val,
              },
            });
            return each3.val;
          }

          // Table field
          if (each3.children?.length) {
            for (const each4 of each3.children) {
              if (
                !each4.children &&
                each4?.render === "true" &&
                each4.serviceKey === serviceKey
              ) {
                this.setState({
                  Give_Val_By_ServiceKey: {
                    ...this.state.Give_Val_By_ServiceKey,
                    [serviceKey]: each4.val,
                  },
                });
                return each4.val;
              }
            }
          }
        }
      }
    }

    return "";
  };

  Next_serviceID = (input, num) => {
    let numb = Number(input.split("#").pop()) + num;

    let nextNO = numb.toString().padStart(4, "0");

    let array = input.split("#");

    array[array?.length - 1] = nextNO;

    return array.join("#");
  };

  COPYTOBELOW = (treeNode) => {
    let INPUT = JSON.parse(JSON.stringify(treeNode));

    let Count = INPUT.children?.length;

    for (let i = 0; i < Count; i++) {
      let temp = JSON.parse(JSON.stringify(INPUT.children[i]));

      temp.title = this.Next_serviceID(temp.title, Count);
      temp.serviceID = this.Next_serviceID(temp.serviceID, Count);
      temp.serviceKey = this.Next_serviceID(temp.serviceKey, Count);

      let tempChildren = temp.children;

      tempChildren?.map((each) => {
        if (each.serviceKey === "Line ID")
          each.val = String(Number(each.val) + Count);
        if (
          each.serviceKey === "Cost Allocation Category" &&
          each.val === "Plan"
        )
          each.val = "Actual";
        each.serviceID = this.Next_serviceID(each.serviceID, Count);
      });

      INPUT.children.push(temp);

      if (i === Count - 1) {
        let found = false;
        let VR2_Form_Json = this.props.VR2_Form_Json;

        VR2_Form_Json?.forEach((each, i) => {
          if (found) return;
          if (each.children && each.children?.length) {
            each.children.forEach((each2, j) => {
              if (found) return;
              if (each2.title === INPUT.title) {
                each2.children = INPUT.children;
                this.props.handleTreeChange(VR2_Form_Json);
                this.props.rerender("noQuit");
                found = true;
                return;
              }
            });
          }
        });
      }
    }
  };

  handleAddRowChanges = async (value, identifier) => {
    this.setState((prev) => ({
      ...prev,
      DialogData: {
        ...prev.DialogData,
        children: prev?.DialogData?.children?.map((each) => {
          if (
            (each?.serviceID === identifier ||
              each?.serviceKey === identifier) &&
            each.onChange_operation
          ) {
            console.log(value, "offer", identifier);

            let get = each.serviceID.split("#");

            get.splice(1, 1);

            get = get.join("#");
            console.log(get);

            let ARRAY =
              this.props.athenaStorage[each.onChange_operation.get_From] ||
              null; //gv

            if (this.props.athenaStorage[get]) {
              ARRAY = this.props.athenaStorage[get];
            }
            if (
              ARRAY === null ||
              !this.props.athenaStorage[each.onChange_operation.get_From]
            ) {
              console.log("Athena store values are not found");
              this.props.showAlert(
                "Athena store values are not found",
                "error"
              );
              return { ...each, val: value };
            }

            let matchKey =
              (ARRAY?.length &&
                Object.keys(ARRAY[0]).find(
                  (eachWrd) => this.trim(eachWrd) === this.trim(each.serviceKey)
                )) ||
              null;

            if (matchKey) {
              let LINES = ARRAY.filter((each) => each[matchKey] === value);
              console.log(
                each,
                `${each.onChange_operation.get_From}`,
                matchKey,
                LINES,
                this.props.athenaStorage
              );

              if (LINES?.length === 1) {
                let LINE = LINES[0];
                Object.keys(LINE)
                  .filter((item) => item != each?.serviceKey)
                  .map((one) => {
                    console.log(LINE, one);

                    this.handleAddRowChanges(LINE[one], one);
                  });
              }
            }
            return { ...each, val: value };
          } else if (
            identifier === each?.serviceID ||
            identifier === each?.serviceKey
          ) {
            if (
              identifier.includes("billingsummary#qty") ||
              identifier === "Qty"
            ) {
              const Rate = Number(this.getValueByservicesID("Rate")) || 0;
              const numValue = Number(value) || 0;
              let baseValue = Rate * numValue;
              this.handleAddRowChanges(baseValue.toFixed(2), "Base Value");
              this.Give_Val_By_ServiceKey("Tax Category");
              const Tax_Category =
                this.Give_Val_By_ServiceKey("Tax Category") || "CGST/SGST";

              const taxPercent =
                Number(this.getValueByservicesID("Tax Percentage")) || 0;

              let totalTaxValue = (baseValue * taxPercent) / 100;
              let totalValue = baseValue + totalTaxValue;

              if (Tax_Category?.includes("IGST")) {
                this.handleAddRowChanges(
                  taxPercent.toFixed(2),
                  "IGST Percentage"
                );
                this.handleAddRowChanges(totalTaxValue.toFixed(2), "IGST");
              }

              // CGST + SGST logic
              else {
                const halfPercent = taxPercent / 2;
                const halfTaxValue = totalTaxValue / 2;

                this.handleAddRowChanges(
                  halfPercent.toFixed(2),
                  "CGST Percentage"
                );
                this.handleAddRowChanges(halfTaxValue.toFixed(2), "CGST");

                this.handleAddRowChanges(
                  halfPercent.toFixed(2),
                  "SGST Percentage"
                );
                this.handleAddRowChanges(halfTaxValue.toFixed(2), "SGST");
              }
              this.handleAddRowChanges(totalTaxValue.toFixed(2), "Tax Value");
              this.handleAddRowChanges(totalValue.toFixed(2), "Total Value");
            }

            if (
              identifier?.includes("billingsummary#rate") ||
              identifier === "Rate"
            ) {
              const Qty = Number(this.getValueByservicesID("Qty")) || 0;
              const numValue = Number(value) || 0;
              let baseValue = Qty * numValue;
              this.handleAddRowChanges(baseValue.toFixed(2), "Base Value");

              this.Give_Val_By_ServiceKey("Tax Category");
              const Tax_Category =
                this.Give_Val_By_ServiceKey("Tax Category") ||
                "CGST/SGST";

              const taxPercent =
                Number(this.getValueByservicesID("Tax Percentage")) || 0;

              let totalTaxValue = (baseValue * taxPercent) / 100;
              let totalValue = baseValue + totalTaxValue;

              if (Tax_Category?.includes("IGST")) {
                this.handleAddRowChanges(
                  taxPercent.toFixed(2),
                  "IGST Percentage"
                );
                this.handleAddRowChanges(totalTaxValue.toFixed(2), "IGST");
              }

              // CGST + SGST logic
              else {
                const halfPercent = taxPercent / 2;
                const halfTaxValue = totalTaxValue / 2;

                this.handleAddRowChanges(
                  halfPercent.toFixed(2),
                  "CGST Percentage"
                );
                this.handleAddRowChanges(halfTaxValue.toFixed(2), "CGST");

                this.handleAddRowChanges(
                  halfPercent.toFixed(2),
                  "SGST Percentage"
                );
                this.handleAddRowChanges(halfTaxValue.toFixed(2), "SGST");
              }
              this.handleAddRowChanges(totalTaxValue.toFixed(2), "Tax Value");
              this.handleAddRowChanges(totalValue.toFixed(2), "Total Value");
            }

            if (
              identifier?.includes("billingsummary#taxpercentage") ||
              identifier === "Tax Percentage"
            ) {
              const BaseValue =
                Number(this.getValueByservicesID("Base Value")) || 0;
              const taxPercent = Number(value) || 0;

              this.Give_Val_By_ServiceKey("Tax Category");
              const Tax_Category =
                this.Give_Val_By_ServiceKey("Tax Category") ||
                "CGST/SGST";

              this.handleAddRowChanges(
                taxPercent ? `${Tax_Category} ${taxPercent}%` : "",
                "Tax Code"
              );

              const totalTaxValue = (BaseValue * taxPercent) / 100;

              this.handleAddRowChanges(
                (BaseValue + totalTaxValue).toFixed(2),
                "Total Value"
              );
              this.handleAddRowChanges(totalTaxValue.toFixed(2), "Tax Value");

              // IGST logic
              if (Tax_Category?.includes("IGST")) {
                this.handleAddRowChanges(
                  taxPercent.toFixed(2),
                  "IGST Percentage"
                );
                this.handleAddRowChanges(totalTaxValue.toFixed(2), "IGST");
              }

              // CGST + SGST logic
              else {
                const halfPercent = taxPercent / 2;
                const halfTaxValue = totalTaxValue / 2;

                this.handleAddRowChanges(
                  halfPercent.toFixed(2),
                  "CGST Percentage"
                );
                this.handleAddRowChanges(halfTaxValue.toFixed(2), "CGST");

                this.handleAddRowChanges(
                  halfPercent.toFixed(2),
                  "SGST Percentage"
                );
                this.handleAddRowChanges(halfTaxValue.toFixed(2), "SGST");
              }
            }

            return { ...each, val: value };
          } else return each;
        }),
      },
    }));
  };

  getValueByservicesID = (identifier) => {
    let VALUE;
    let { DialogData } = this.state;
    VALUE = DialogData?.children?.find(
      (each) =>
        each?.serviceID === identifier || each?.serviceKey === identifier
    )?.val;
    return VALUE;
  };

  tableRowAdd = (
    obj = null,
    parentObj = null,
    ROWNUM = null,
    confirmation = false
  ) => {
    let VR2_Form_Json = this.props.VR2_Form_Json;
    if (!confirmation) {
      let OBJ = JSON.parse(JSON.stringify(obj));
      let parent_obj = JSON.parse(JSON.stringify(parentObj));
      parent_obj.title = this.Next_serviceID(parent_obj.title, 1);
      parent_obj.serviceID = this.Next_serviceID(parent_obj.serviceID, 1);
      parent_obj.serviceKey = this.Next_serviceID(parent_obj.serviceKey, 1);

      OBJ?.map((each, i) => {
        if (OBJ[i].serviceKey === "Line ID")
          OBJ[i].val = String(Number(OBJ[i].val) + 1);
        else if (OBJ[i].serviceKey === "ForPrdFrom") OBJ[i].val = OBJ[i].val;
        else if (OBJ[i].serviceKey === "ForPrdTo") OBJ[i].val = OBJ[i].val;
        else OBJ[i].val = "";
        OBJ[i].serviceID = this.Next_serviceID(each.serviceID, 1);
      });
      parent_obj.children = OBJ;

      this.setState({ ...this.state, DialogData: parent_obj, ROWNUM });
    } else {
      let found = false;
      VR2_Form_Json?.forEach((each, i) => {
        if (found) return;
        if (each.children && each.children?.length) {
          each.children.forEach((each2, j) => {
            if (found) return;
            if (each2.children && each2.children?.length) {
              each2.children.forEach((each3, m) => {
                if (found) return;
                if (
                  each3?.serviceID?.includes("#") &&
                  parentObj?.serviceID?.includes("#") &&
                  each3?.serviceID?.split("#")?.slice(0, -1)[0] ===
                  parentObj?.serviceID?.split("#")?.slice(0, -1)[0]
                ) {
                  each2.children.push(parentObj);

                  this.props.handleTreeChange(VR2_Form_Json);
                  this.props.rerender("noQuit");
                  found = true;
                  this.setState({ ...this.state, DialogData: null });
                  return;
                }
              });
            }
          });
        }
      });
    }
  };

  tableRowDel = (obj, parentObj) => {
    const parentID = parentObj.serviceID;

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;
    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, m) => {
              if (found) return;
              if (each3.serviceID === parentID) {
                each2.children.splice(-1);

                this.props.handleTreeChange(VR2_Form_Json);
                this.props.rerender("noQuit");
                found = true;
                return;
              }
            });
          }
        });
      }
    });
  };

  tableRowDelByServiceID = (obj, parentObj) => {
    const parentID = parentObj.serviceID;
    console.log("Deleting row:", parentObj, obj);

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;
    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, m) => {
              if (found) return;
              if (each3.serviceID === parentID) {
                let filteredRows = each2.children
                  .filter((row) => row.serviceID !== parentID)
                  .map((row, index) => {
                    if (Array.isArray(row.children)) {
                      row.children = row.children.map((child, i) =>
                        child.title === "Line ID" && i === 0
                          ? { ...child, val: index + 1 }
                          : child
                      );
                    }
                    return row;
                  });
                each2.children = filteredRows;

                this.props.handleTreeChange(VR2_Form_Json);
                this.props.rerender("noQuit");
                found = true;
                return;
              }
            });
          }
        });
      }
    });
  };

  //from form

  option_undef = (childrenNode) => {
    console.log("if option_undef", childrenNode.title);
  };

  myChangeHandler = (event, date) => {
    let serviceKey = event.target.name;
    let serviceID = event.target.id;
    let val = event.target.value;

    if (date) {
      let date = moment(val, "YYYY-MM-DD").format("DD-MM-YYYY");

      val = date === "Invalid date" ? val : date;
    }

    console.log(val);

    let DateTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    console.log(DateTime);

    let logs = this.props.changeLogs;
    let vals = this.props.storeVals;

    logs[serviceID] = {
      serviceKey: serviceKey,
      serviceID: serviceID,
      value: val,
      DateTime,
      user: this.props?.userData?.USR_Email,
    };

    vals[serviceID] = val;

    // changeValByserviceID(this.props.VR2_Form_Json, this.props.formArray, serviceID, "val", val, serviceKey)

    this.changeValByserviceID(serviceID, "val", val);

    this.props.updateChangeLogs(logs);
    this.props.updateStoreVals(vals);

    // this.setState({ [serviceKey]: val, logs });
    this.props.rerender("noQuit");
  };

  onChangeEventForBillingSummary = (ServicesKey, Val, rowNO) => {
    console.log(ServicesKey, Val, rowNO);

    let Obj = {
      [ServicesKey]: Val,
      "Tax Percentage": null,
      "Tax Category": null,
    };

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, k) => {
              if (found) return;

              if (
                !each3.children &&
                each3?.render &&
                each3?.render === "true" &&
                each3.serviceKey === "Tax Category"
              ) {
                Obj = { ...Obj, "Tax Category": each3.val };
              } else if (each3.children && each3.children?.length) {
                each3.children.forEach((each4, k) => {
                  if (found) return;

                  if (
                    !each4.children &&
                    each4?.render &&
                    each4?.render === "true" &&
                    (each4.serviceKey === "Qty" ||
                      each4.serviceKey === "Rate" ||
                      each4.serviceKey === "Tax Percentage") &&
                    each4.serviceID.includes("billingsummary")
                  ) {
                    Obj = {
                      ...Obj,
                      "Tax Percentage":
                        each4.serviceKey === "Tax Percentage"
                          ? typeof Number(each4.val) == "NaN"
                            ? 0
                            : each4.val
                          : null,
                    };
                    const isQtyOrRate = ServicesKey === "Qty" ? "Rate" : "Qty";

                    Obj = {
                      ...Obj,
                      [isQtyOrRate]:
                        each4.serviceKey === isQtyOrRate
                          ? Number.isNaN(each4.val)
                            ? 0
                            : each4.val
                          : Obj[isQtyOrRate] || null,
                    };
                    console.log(Obj, isQtyOrRate, each4.serviceKey);

                    found = Object.values(Obj).every((val) => val !== null);
                  }
                });
              }
            });
          }
        });
      }
    });

    console.log(
      Obj,
      Object.values(Obj).every((val) => val !== null)
    );

    if (!found) return;
    let BaseValue = (Number(Obj["Rate"]) * Number(Obj["Qty"])).toFixed(2);
    let totaltaxvalue = (
      (Number(Obj["Tax Percentage"]) * Number(BaseValue)) /
      100
    ).toFixed(2);

    this.changeValBy_row(
      "Tax Value",
      "serviceKey",
      "val",
      totaltaxvalue,
      rowNO
    );

    this.changeValBy_row(
      "Total Value",
      "serviceKey",
      "val",
      (Number(BaseValue) + Number(totaltaxvalue)).toFixed(2),
      rowNO
    );

    this.changeValBy_row(
      "Base Value",
      "serviceKey",
      "val",
      Number(BaseValue).toFixed(2),
      rowNO
    );

    if (Obj["Tax Category"].includes("IGST")) {
      this.changeValBy_row("IGST", "serviceKey", "val", totaltaxvalue, rowNO);
      return;
    }

    this.changeValBy_row(
      "CGST",
      "serviceKey",
      "val",
      (Number(totaltaxvalue) / 2).toFixed(2),
      rowNO
    );
    this.changeValBy_row(
      "SGST",
      "serviceKey",
      "val",
      (Number(totaltaxvalue) / 2).toFixed(2),
      rowNO
    );
  };

  changeValByserviceID = (serviceID, key, val) => {
    console.log(serviceID, val, key);

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, row) => {
              if (found) return;
              if (
                !each3.children &&
                each3?.render &&
                each3?.render === "true" &&
                each3.serviceID === serviceID
              ) {
                each3[key] = val;
                this.props.handleTreeChange(VR2_Form_Json);
                found = true;
                return;
              } else if (each3.children && each3.children?.length) {
                each3.children.forEach((each4, m) => {
                  if (found) return;
                  if (
                    each4?.render === "true" &&
                    each4.serviceID === serviceID
                  ) {
                    each4[key] = val;

                    this.props.handleTreeChange(VR2_Form_Json);
                    // this.props.rerender()
                    found = true;
                    if (each4.serviceKey === "Tax Percentage")
                      this.onTaxPerChange(val, row);
                    if (
                      each4.serviceKey === "Qty" ||
                      each4.serviceKey === "Rate"
                    )
                      this.onChangeEventForBillingSummary(
                        each4.serviceKey,
                        val,
                        row
                      );
                    // if(each4.serviceKey === "PO/IP Item Ref" && key === "val") this.onPOIPItemRefChange(val, row)

                    return;
                  }
                });
              }
            });
          }
        });
      }
    });
  };

  ChangeDynamicOptions = (serviceID, key, val) => {
    console.count("ChangeDynamicOptions");
    let serviceIDExtracted =
      serviceID.includes("#") && serviceID.split("#").slice(0, -1).join("#");
    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, row) => {
              if (found) return;
              if (
                !each3.children &&
                each3?.render &&
                each3?.render === "true" &&
                each3?.serviceID == serviceID
              ) {
                each3[key] = val;

                this.props.handleTreeChange(VR2_Form_Json);
                found = true;
                return;
              } else if (each3.children && each3.children?.length) {
                each3.children.forEach((each4, m) => {
                  if (found) return;
                  if (
                    each4?.render === "true" &&
                    each4?.serviceID?.split("#")?.slice(0, -1)?.join("#") ===
                    serviceIDExtracted
                  ) {
                    // console.log(
                    //   each4?.serviceID?.split("#")?.slice(0, -1)?.join("#"),
                    //   each4.serviceID,
                    //   serviceIDExtracted,
                    //   "each5"
                    // );

                    if (
                      (this.state.token === "BillExtract" ||
                        this.state.token === "GoodsAndServicesEntries") &&
                      (each4.serviceKey === "Item ID" ||
                        each4.serviceKey === "ForPrdFrom" ||
                        each4.serviceKey === "ForPrdTo") &&
                      each4.serviceID === serviceID
                    ) {
                      this.costAllocationMethod(row, each4.serviceKey, val);
                    }

                    each4[key] = val;

                    if (
                      each4.serviceKey === "Tax Percentage" &&
                      serviceID === each4.serviceID
                    ) {
                      this.onTaxPerChange(val, row);
                      found = true;
                    }
                    // if(each4.serviceKey === "PO/IP Item Ref" && key === "val") this.onPOIPItemRefChange(val, row)
                  }
                });
              }
            });
          }
        });
      }
    });
    this.props.handleTreeChange(VR2_Form_Json);
  };

  changeValByserviceID_or_Key = (serviceID_or_Key, matchBy, key, val, push) => {
    console.log(serviceID_or_Key, val);

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, k) => {
              if (found) return;

              if (
                !each3.children &&
                each3?.render &&
                each3?.render === "true" &&
                this.trim(each3[matchBy]) === this.trim(serviceID_or_Key)
              ) {
                if (push) {
                  console.log(each3);

                  let arr = each3[key];

                  arr.push(val);
                  console.log(arr);
                  // console.log(arr.push(val))
                  each3[key] = arr;
                } else {
                  each3[key] = val;
                }

                this.props.handleTreeChange(VR2_Form_Json);
                found = true;

                return;
              } else if (each3.children && each3.children?.length) {
                each3.children.forEach((each4, m) => {
                  if (found) return;
                  if (
                    each4?.render === "true" &&
                    this.trim(each4[matchBy]) === this.trim(serviceID_or_Key)
                  ) {
                    each4[key] = val;
                    console.log("super2");

                    this.props.handleTreeChange(VR2_Form_Json);
                    // if( each4.serviceKey === "PO/IP Item Ref") found = false
                    found = true;
                    return;
                  }
                });
              }
            });
          }
        });
      }
    });
  };

  onPOIPItemRefChange = (val, rowNO) => {
    let Vendor_ID;
    let Item_ID;

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, k) => {
              if (found) return;
              if (
                !each3.children &&
                each3?.render &&
                each3?.render === "true" &&
                each3.serviceKey === "Vendor ID"
              ) {
                Vendor_ID = each3.val;
                if (Vendor_ID !== undefined && Item_ID !== undefined)
                  found = true;
                if (found) return;
              }
            });
          }

          if (
            each2.children &&
            each2.children?.length &&
            each2.children[rowNO] &&
            each2.children[rowNO].children
          ) {
            each2.children[rowNO].children.forEach((each4, m) => {
              if (found) return;
              if (
                each4?.render &&
                each4?.render === "true" &&
                each4.serviceKey === "Item ID"
              ) {
                Item_ID = each4.val;
                if (Vendor_ID !== undefined && Item_ID !== undefined)
                  found = true;
                if (found) return;
              }
            });
          }
        });
      }
    });

    console.log(Vendor_ID, Item_ID);

    this.setState({
      BillExtract_theme_save: {
        ItemID: Item_ID,
        VendorID: Vendor_ID,
        KeyWord: "",
      },
    });
  };

  onChange_BillExtract_theme_save = (e) => {
    let key = e.target.id;
    let val = e.target.value;

    this.setState(
      {
        ...this.state,
        BillExtract_theme_save: {
          ...this.state.BillExtract_theme_save,
          [key]: val,
        },
      },
      () => {
        console.log(this.state.BillExtract_theme_save);
      }
    );
  };

  save_BillExtract_theme = (e) => {
    e.preventDefault();

    let obj = this.state.BillExtract_theme_save;

    postRequest("api/vr2/save_BillExtract_theme", obj).then((res) => {
      if (res.res.status === "success") {
        this.setState({ BillExtract_theme_save: false }, () => { });
      }
    });
  };

  onTaxPerChange = (Tax_Percentage, rowNO) => {
    let Tax_Category;
    let BaseValue;

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, k) => {
              if (found) return;

              if (
                !each3.children &&
                each3?.render &&
                each3?.render === "true" &&
                each3.serviceKey === "Tax Category"
              ) {
                Tax_Category = each3.val;
              } else if (each3.children && each3.children?.length) {
                each3.children.forEach((each4, k) => {
                  if (found) return;
                  console.log(
                    each4,
                    !each4.children,
                    each4?.render,
                    each4?.render === "true",
                    each4.serviceKey === "Base Value",
                    !each4.children &&
                    each4?.render &&
                    each4?.render === "true" &&
                    each4.serviceKey === "Base Value",
                    "each4"
                  );
                  if (
                    !each4.children &&
                    each4?.render &&
                    each4?.render === "true" &&
                    each4.serviceKey === "Base Value" &&
                    each4.serviceID.includes("billingsummary")
                  ) {
                    BaseValue =
                      typeof Number(each4.val) == "NaN" ? 0 : each4.val;
                    found = true;
                  }
                });
              }
            });
          }
        });
      }
    });
    console.log(BaseValue, "basevalue");

    if (!BaseValue) return;

    let taxCode =
      typeof Number(Tax_Percentage) == "NaN"
        ? 0
        : Tax_Category + " " + String(Number(Tax_Percentage)) + "%";
    let totaltaxvalue = (
      (Number(Tax_Percentage) * Number(BaseValue)) /
      100
    ).toFixed(2);

    this.changeValBy_row("Tax Code", "serviceKey", "val", taxCode, rowNO);
    this.changeValBy_row(
      "Tax Value",
      "serviceKey",
      "val",
      totaltaxvalue,
      rowNO
    );

    this.changeValBy_row(
      "Total Value",
      "serviceKey",
      "val",
      (Number(BaseValue) + Number(totaltaxvalue)).toFixed(2),
      rowNO
    );

    if (taxCode.includes("IGST")) {
      this.changeValBy_row(
        "IGST Percentage",
        "serviceKey",
        "val",
        Number(Tax_Percentage).toFixed(2),
        rowNO
      );
      this.changeValBy_row("IGST", "serviceKey", "val", totaltaxvalue, rowNO);
      return;
    }
    this.changeValBy_row(
      "CGST Percentage",
      "serviceKey",
      "val",
      (Number(Tax_Percentage) / 2).toFixed(2),
      rowNO
    );
    this.changeValBy_row(
      "CGST",
      "serviceKey",
      "val",
      (Number(totaltaxvalue) / 2).toFixed(2),
      rowNO
    );
    this.changeValBy_row(
      "SGST Percentage",
      "serviceKey",
      "val",
      (Number(Tax_Percentage) / 2).toFixed(2),
      rowNO
    );
    this.changeValBy_row(
      "SGST",
      "serviceKey",
      "val",
      (Number(totaltaxvalue) / 2).toFixed(2),
      rowNO
    );
  };

  costAllocationMethod = (rowNO, serviceKey, val) => {
    console.log(rowNO, '"costAllocationMethod"');

    let obj = {
      ForPrdFrom: "",
      ForPrdTo: "",
      ItemID: "",
    };

    obj[serviceKey.replaceAll(/\s/g, "")] = val;

    console.log(obj);

    let { ForPrdFrom, ForPrdTo, ItemID } = obj;

    let VendorID = "";

    let _ID_KEY;
    if (this.state.token === "BillExtract") _ID_KEY = "Vendor ID";

    if (this.state.token === "GoodsAndServicesEntries") _ID_KEY = "Sender ID";

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, k) => {
              if (found) return;
              if (
                !each3.children &&
                each3?.render &&
                each3?.render === "true" &&
                each3.serviceKey === _ID_KEY
              ) {
                VendorID = each3.val;
                if (ForPrdFrom && ForPrdTo && ItemID && VendorID) found = true;
                if (found) return;
              }
            });
          }
          if (
            each2.children &&
            each2.children?.length &&
            each2.children[rowNO] &&
            each2.children[rowNO].children
          ) {
            each2.children[rowNO].children.forEach((each4, m) => {
              if (found) return;
              if (
                each4?.render === "true" &&
                (each4.serviceKey === "ForPrdFrom" ||
                  each4.serviceKey === "ForPrdTo" ||
                  each4.serviceKey === "Item ID")
              ) {
                if (each4.serviceKey === "ForPrdFrom") {
                  if (!ForPrdFrom) ForPrdFrom = each4.val;

                  if (ForPrdFrom && ForPrdTo && ItemID && VendorID)
                    found = true;
                  if (found) return;
                }

                if (each4.serviceKey === "ForPrdTo") {
                  if (!ForPrdTo) ForPrdTo = each4.val;

                  if (ForPrdFrom && ForPrdTo && ItemID && VendorID)
                    found = true;
                  if (found) return;
                }

                if (each4.serviceKey === "Item ID") {
                  if (!ItemID) ItemID = each4.val;

                  if (ForPrdFrom && ForPrdTo && ItemID && VendorID)
                    found = true;
                  if (found) return;
                }
              }
            });
          }
        });
      }
    });

    console.log(ForPrdFrom, ForPrdTo, ItemID, VendorID);

    if (ForPrdFrom && ForPrdTo && ItemID && VendorID) {
      let input = {
        ForPrdFrom: moment(ForPrdFrom, "DD-MM-YYYY").format("YYYY-MM-DD"),
        ForPrdTo: moment(ForPrdTo, "DD-MM-YYYY").format("YYYY-MM-DD"),
        ItemID,
        VendorID,
        ORG_ID_CONST: this.props.ORG_ID_CONST,
      };

      postRequest("api/vr2apicall/getcostAllocationMethods", input).then(
        (res) => {
          if (res.res.status === "success") {
            let DATA = JSON.parse(res.res.data);
            // let DATA = JSON.parse("[{\"costallocationmethod\":\"USERCNT-ECOM#USERCNT-ECOM&LMS\"}]")
            console.log("cost allocation method", DATA);

            if (DATA?.length) {
              let options = DATA.flatMap((obj) =>
                obj.costallocationmethod.split("#")
              );

              console.log(options);

              let ok = (
                <Popup
                  content={
                    <div className="row m-4">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Cost Allocation Method</th>
                          </tr>
                        </thead>
                        <tbody>
                          {options?.map((each, index) => {
                            return (
                              <tr
                                key={index}
                                onClick={() => {
                                  this.changeValBy_row(
                                    "CostAllocationMethod",
                                    "serviceKey",
                                    "val",
                                    each,
                                    rowNO
                                  );

                                  this.setState({ pop_up_1: null });
                                }}
                              >
                                <td>{each}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  }
                  handleClose={() => this.setState({ pop_up_1: null })}
                />
              );

              this.setState({ pop_up_1: ok });
            }
          }
        }
      );
      postRequest("api/vr2apicall/getSectionName", input).then((res) => {
        if (res.res.status === "success") {
          let DATA = JSON.parse(res.res.data);
          // let DATA = JSON.parse("[{\"costallocationmethod\":\"USERCNT-ECOM#USERCNT-ECOM&LMS\"}]")
          console.log(DATA);

          if (DATA?.length) {
            let options = DATA.flatMap((obj) => obj.SectionName.split("#"));

            console.log(options);

            let ok = (
              <Popup
                content={
                  <div className="row m-4">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Section Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {options?.map((each, index) => {
                          return (
                            <tr
                              key={index}
                              onClick={() => {
                                this.changeValBy_row(
                                  "Section Name",
                                  "serviceKey",
                                  "val",
                                  each,
                                  rowNO
                                );

                                this.setState({ pop_up_2: null });
                              }}
                            >
                              <td>{each}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                }
                handleClose={() => this.setState({ pop_up_2: null })}
              />
            );

            this.setState({ pop_up_2: ok });
          }
        }
      });
    }
  };

  changeValBy_row = (serviceID_or_Key, matchBy, key, val, rowNO) => {
    console.log(serviceID_or_Key, matchBy, key, val, rowNO, "rowNO");

    console.log(serviceID_or_Key, val);

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (
            each2.children &&
            each2.children?.length &&
            each2.children[rowNO] &&
            each2.children[rowNO].children
          ) {
            each2.children[rowNO].children.forEach((each4, m) => {
              if (found) return;
              if (
                each4?.render === "true" &&
                this.trim(each4[matchBy]) === this.trim(serviceID_or_Key)
              ) {
                if (
                  (this.state.token === "BillExtract" ||
                    this.state.token === "GoodsAndServicesEntries") &&
                  (each4.serviceKey === "Item ID" ||
                    each4.serviceKey === "ForPrdFrom" ||
                    each4.serviceKey === "ForPrdTo")
                ) {
                  this.costAllocationMethod(rowNO, each4.serviceKey, val);
                }

                each4[key] = val;
                console.log("super243");

                this.props.handleTreeChange(VR2_Form_Json);
                found = true;
                if (each4.serviceKey === "Tax Percentage")
                  this.onTaxPerChange(val, rowNO);

                return;
              }
            });
          }
        });
      }
    });
  };

  onDropDownValueChange = (ev, valEmpty, no_onBlur) => {
    let serviceID = ev.target.id;
    let serviceKey = ev.target.name;
    let val = ev.target.value;
    console.log(serviceID, "serviceid");
    let serviceIDLastSegment = serviceID.split("#").pop();
    console.log(serviceIDLastSegment);

    this.setState(
      {
        lastServiceIDSegment: serviceIDLastSegment,
      },
      () => {
        console.log(
          `billingsummary#basevalue#${this.state.lastServiceIDSegment}`,
          "billingsummary last segment"
        );
      }
    );
    //mbp
    if (val === "DYNAMIC") {
      console.log("dropdown chandge value ", val);
      console.log(this.state.costAllocationMethodOptions);
      this.setState({
        isPopupOpen: true,
        popupServiceId: serviceID,
        popupserviceKey: serviceKey,
      });
    }

    // changeValByserviceID(this.props.VR2_Form_Json, this.props.formArray, serviceID, "val", val, serviceKey)

    this.changeValByserviceID(serviceID, "val", val);

    let DateTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    console.log(DateTime);

    let logs = this.props.changeLogs;
    let vals = this.props.storeVals;

    logs[serviceID] = {
      serviceKey: serviceKey,
      serviceID: serviceID,
      value: val,
      DateTime,
      user: this.props?.userData?.USR_Email,
    };

    vals[serviceID] = val;
    // let formArray_obj={}

    // this.props.formArray.forEach( each => {
    //     formArray_obj[each.serviceKey] = each.val ? each.val : ""
    // })

    // changeDependencyValues(serviceID, this.props.formArray, formArray_obj, this.props.VR2_Form_Json, valEmpty && valEmpty === "false" ? false : true );

    this.props.updateChangeLogs(logs);
    this.props.updateStoreVals(vals);

    this.props.rerender();
    this.setState(
      { [serviceKey]: val, logs },

      () =>
        no_onBlur
          ? null
          : this.onBlur({
            target: {
              id: serviceID,
              value: val,
            },
          })
    );
  };

  //mbp
  onDropDownDynamicValueChange = (no_onBlur) => {
    let serviceID = this.state.popupServiceId;
    let serviceKey = this.state.popupserviceKey;
    let val = this.state.dynamicValue;
    console.log("from the ondropdowndynamicvaluechange", val);

    // changeValByserviceID(this.props.VR2_Form_Json, this.props.formArray, serviceID, "val", val, serviceKey)

    this.changeValByserviceID(serviceID, "val", val);

    let DateTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    console.log(DateTime);

    let logs = this.props.changeLogs;
    let vals = this.props.storeVals;

    logs[serviceID] = {
      serviceKey: serviceKey,
      serviceID: serviceID,
      value: val,
      DateTime,
      user: this.props?.userData?.USR_Email,
    };

    vals[serviceID] = val;
    // let formArray_obj={}

    // this.props.formArray.forEach( each => {
    //     formArray_obj[each.serviceKey] = each.val ? each.val : ""
    // })

    // changeDependencyValues(serviceID, this.props.formArray, formArray_obj, this.props.VR2_Form_Json, valEmpty && valEmpty === "false" ? false : true );

    this.props.updateChangeLogs(logs);
    this.props.updateStoreVals(vals);

    this.props.rerender();
    this.setState(
      { [serviceKey]: val, logs },

      () =>
        no_onBlur
          ? null
          : this.onBlur({
            target: {
              id: serviceID,
              value: val,
            },
          })
    );
  };

  if2hashRemoveLast = (myString) => {
    if (myString.includes("#") && (myString.match(/#/g) || [])?.length === 2) {
      // only containd 2 #

      let str = myString.split("#");

      str.splice(-1);

      return str.join("#");
    } else {
      return myString;
    }
  };

  onBlur = (e) => {
    let val = e.target.value;
    let id = e.target.id;

    console.log(val);
    console.log(id);

    if (val) {
      let API = _.filter(
        this.props.dependency_json,
        (item) =>
          item.type === "apiCall" &&
          this.if2hashRemoveLast(id).includes(item.parentId)
      );

      console.log(API);

      if (API?.length && API?.length === 1) {
        let obj = {
          LOGS: this.props.changeLogs,
          TREE_JSON: this.props.VR2_Form_Json,
        };

        console.log(obj);

        this.setState({ showSpinner: true }, () => {
          postRequest(
            `api/vr2/EditJson?module=${localStorage.getItem(
              "module"
            )}&screenName=${this.state.token}`,
            obj
          ).then((res) => {
            if (res.res.status === "success") {
              console.log(res.res.data);

              this.props.handleTreeChange(res.res.data);
            }

            this.setState({ showSpinner: false });
          });
        });
      }
    }
  };

  date_DD_MM_YYYY_TO_YYYY_MM_DD = (json) => {
    let ok = JSON.parse(JSON.stringify(json));

    let date = moment(ok.val, "DD-MM-YYYY").format("YYYY-MM-DD");

    return date === "Invalid date" ? ok.val : date;
  };

  current_date = (childrenNode) => {
    let date = moment(new Date()).format("DD-MM-YYYY");
    let ev = {
      target: {
        id: childrenNode.serviceID,
        name: childrenNode.serviceKey,
        value: date,
      },
    };

    this.myChangeHandler(ev);
  };

  yesterday_date = (childrenNode) => {
    let date = moment(new Date()).subtract(1, "day").format("DD-MM-YYYY");
    let ev = {
      target: {
        id: childrenNode.serviceID,
        name: childrenNode.serviceKey,
        value: date,
      },
    };

    this.myChangeHandler(ev);
  };

  generateUniqueNumber = () => {
    var timestamp = new Date().getTime();
    var uniqueNumber = timestamp.toString().substr(0, 10);

    console.log(uniqueNumber);
    return uniqueNumber;
  };

  removeSpecialCharacters_exceptDOT = (str) => {
    return str.replace(/[^\w\s.]/gi, ""); // only dot allowed
  };

  removeSpecialCharacters = (str) => {
    return str.replace(/[^\w\s]/gi, "");
  };

  onUpload = (e, childrenNode) => {
    let serviceKey = e.target.name;
    let serviceID = e.target.id;

    let DateTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    console.log(DateTime);

    let logs = this.props.changeLogs;
    let vals = this.props.storeVals;

    let file = e.target.files[0];
    let files = Array.from(e.target.files);
    const { MAX_TOTAL_SIZE } = externals;

    if (
      file &&
      e.target.files &&
      e.target.files?.length &&
      files.every((file) => file.name.toLowerCase().includes("pdf")) &&
      files.every((file) => file.size < MAX_TOTAL_SIZE)
    ) {
      let fileName =
        this.generateUniqueNumber() +
        this.removeSpecialCharacters_exceptDOT(file.name);

      console.log(fileName);

      const Module = localStorage.getItem("module");
      const screenName = this.removeSpecialCharacters(this.state.token);
      const fieldName = this.removeSpecialCharacters(serviceKey);

      let s3key = `UploadedFiles/${Module}/${screenName}/${fieldName}/${fileName}`;

      console.log(s3key);

      const formData = new FormData();
      formData.append("file", file);

      postRequest(
        `api/vr2/uploadPDF?module=${localStorage.getItem(
          "module"
        )}&screenName=${screenName}&fieldName=${fieldName}&fileName=${fileName}`,
        formData
      ).then((res) => {
        if (res.res.status === "success") {
          this.changeValByserviceID(serviceID, "val", s3key);

          logs[serviceID] = {
            serviceKey: serviceKey,
            serviceID: serviceID,
            value: s3key,
            DateTime,
            user: this.props?.userData?.USR_Email,
          };
          vals[serviceID] = s3key;

          this.props.updateChangeLogs(logs);
          this.props.updateStoreVals(vals);

          this.props.rerender("noQuit");
          this.setState(
            {
              [serviceID]: file,
            },
            () =>
              this.onBlur({
                target: {
                  id: serviceID,
                  value: file,
                },
              })
          );
        }
      });
      this.setState({ ValidationError: "" });
    } else if (
      files.every((file) => file.name.toLowerCase().includes("pdf")) &&
      Number(MAX_TOTAL_SIZE) <= file.size
    ) {
      this.setState((prevState) => ({
        ValidationError: {
          ...prevState.ValidationError,
          [childrenNode.serviceID]: `The total size of all files must not exceed 50 MB. Currently: ${(
            file.size /
            (1024 * 1024)
          ).toFixed(2)} MB`,
        },
      }));
    } else {
      console.log(file.size + " " + typeof file.size + " " + MAX_TOTAL_SIZE);

      console.log(
        files.every((file) => file.name.toLowerCase().includes("pdf"))
      );
      this.setState((prevState) => ({
        ValidationError: {
          ...prevState.ValidationError,
          [childrenNode.serviceID]: "This field extension is mismatching",
        },
      }));
    }
  };

  openPDF = (e, childrenNode) => {
    e.preventDefault();

    postRequest(`api/vr2/getPDF_file`, { key: childrenNode.val }).then(
      (res) => {
        if (res.res.status === "success") {
          // if(childrenNode.subtype === 'upload_show') this.props.update_one_side_PDF_Key(res.res.data)

          // else
          this.setState({
            showPopUP: childrenNode.serviceID,
            popData: res.res.data,
          });
        }
      }
    );
  };

  ifReject = (childrenNode, children_Node) => {
    console.log(children_Node);

    let reason = children_Node.find((each) => each.serviceKey === "Reason");

    if (reason) {
      this.setState({ ask_reason: reason });
    }
  };

  ifNotReject = (childrenNode, children_Node) => {
    let reason = children_Node.find((each) => each.serviceKey === "Reason");

    if (reason && reason.val) {
      let ev = {
        target: {
          id: reason.serviceID,
          name: reason.serviceKey,
          value: "",
        },
      };

      this.myChangeHandler(ev);
    }
  };

  trim = (str) => {
    return str?.replace(/\s+/g, "")?.toLowerCase() || "";
  };

  dynamic_option_fn = async (childrenNode, index = null) => {
    if (!this.dynamicLoading) {
      this.dynamicLoading = {};
    }
    console.log("Her11111111111111e", this.state.apiExecution);

    const loadingKey = childrenNode.serviceID;

    if (this.dynamicLoading[loadingKey]) {
      console.log("SKIP - Already Loading:", loadingKey);
      return;
    }


    console.count("DYNAMIC OPTION API");


    if (childrenNode.editable === "false" && childrenNode.type !== "input") {
      return;
    }
    if (childrenNode.dynamic_option.api_Directory) {
      let hit = `${childrenNode.dynamic_option.api_Directory}?query_Name=${childrenNode.dynamic_option.query_Name}`;

      let array;
      console.log(childrenNode, "here");

      if (childrenNode.dynamic_option.dynamic_query) {
        array = [];

        for (const each of childrenNode.dynamic_option.dynamic_query || []) {

          if (each.emailid) {

            array.push({
              replaceStringWith: each.replaceStringWith,
              value: this.props?.userData?.USR_Email || "",
            });

          } else if (each.getValueFrom === "Organization ID") {

            const value = this.Give_Val_By_ServiceKey(each.getValueFrom);

            array.push({
              replaceStringWith: each.replaceStringWith,
              value: value || "",
            });

          } else if (each.getValueFrom === "Interim ID") {

            const value = this.Give_Val_By_ServiceKey(each.getValueFrom);

            const obj = {
              replaceStringWith: each.replaceStringWith,
              value:
                this.props?.selectedItem?.BillNumber ||
                value ||
                this.props.storeVals?.["billworkflowinfo#interimid"] ||
                "",
            };

            const companyid = obj.value;

            array.push(obj);

          } else {

            const value = this.Give_Val_By_ServiceKey(each.getValueFrom);

            array.push({
              replaceStringWith: each.replaceStringWith,
              value: value || "",
            });

          }

        }

        console.log(
          array,
          childrenNode.serviceID + "llllllllllllllllllllllllllllll"
        );
      }
      console.log("hitting", hit, childrenNode);
      console.log("Current Options Length:", childrenNode.options?.length || 0);

      //mbp
      let emptyValues =
        array
          ?.map((each) => {
            if (each.value === "") {
              return each.replaceStringWith;
            }
          })
          .filter((each) => each !== undefined) || [];

      console.log(
        emptyValues.length === 0 || !childrenNode.dynamic_option.dynamic_query,
        "hitting",
        hit
      );
      console.count("POST REQUEST");
      console.log({
        hit,
        query: childrenNode.dynamic_option.query_Name,
        serviceKey: childrenNode.serviceKey,
        emptyValues,
        payload: array,
      });
      const loadingStateKey = childrenNode.serviceKey + "$" + String(index);
      if (emptyValues.length === 0 || !childrenNode.dynamic_option.dynamic_query) {
        this.setState((prevState) => ({
          apiExecution: {
            ...prevState.apiExecution,
            [loadingStateKey]: true,
          },
        }));

        postRequest(hit, array ? { info: array } : null).then((res) => {
          if (res.res.status === "success") {
            this.dynamicLoading[loadingKey] = true;
            let DATA =
              res.res.data && res.res.data?.length
                ? JSON.parse(res.res.data)
                : [];

            if (DATA?.length) {
              if (childrenNode.dynamic_option.what_to_store) {
                let athenaStorage = this.props.athenaStorage;

                athenaStorage[childrenNode.dynamic_option.what_to_store] = DATA;

                this.props.updateAthenaStorage(athenaStorage);
              }

              // if(!childrenNode.options || !childrenNode.options?.length){

              let matchKey = Object.keys(DATA[0]).find(
                (each) => this.trim(each) === this.trim(childrenNode.serviceKey)
              );
              console.log(matchKey, "MatchKey");

              if (matchKey) {
                let newSet = [...new Set(DATA?.map((each) => each[matchKey]))];

                let options = [];

                newSet.forEach((one) => {
                  options.push({
                    label: one,
                    value: one,
                  });
                });

                this.ChangeDynamicOptions(
                  childrenNode.serviceID,
                  "options",
                  options
                );
                console.count("RERENDER");
                // this.props.rerender();
              }
              // }
            } else {
              this.ChangeDynamicOptions(childrenNode.serviceID, "options", []);
              console.count("RERENDER");
              this.props.rerender();
            }
          }
        }).finally(() => {
          const key = childrenNode.serviceKey + "$" + String(index);
          this.setState(prevState => ({
            apiExecution: {
              ...prevState.apiExecution,
              [key]: false
            }
          }));
          this.dynamicLoading[loadingKey] = false;
        });
      }
    }
  };

  removeSpecialChars = (str) => {
    return str.replace(/[^\w\s]/gi, "");
  };

  onChange_operation = (childrenNode, val, rowNO) => {
    let get = childrenNode.serviceID.split("#");

    get.splice(1, 1);

    get = get.join("#");
    console.log(get);

    let ARRAY =
      this.props.athenaStorage[
      `${childrenNode.onChange_operation.get_From}#${childrenNode.serviceID.split("#")[2]
      }`
      ] ||
      this.props.athenaStorage[childrenNode.onChange_operation.get_From] ||
      null; //gv

    if (this.props.athenaStorage[get]) {
      ARRAY = this.props.athenaStorage[get];
    }
    console.log(
      childrenNode.onChange_operation,
      this.props.athenaStorage,
      childrenNode.onChange_operation.get_From,
      "onchange"
    );

    let matchKey =
      (ARRAY?.length &&
        Object.keys(ARRAY[0]).find(
          (each) => this.trim(each) === this.trim(childrenNode.serviceKey)
        )) ||
      null;

    if (matchKey) {
      let LINES = ARRAY.filter((each) => each[matchKey] === val);
      console.log("onchange1");
      console.log(
        childrenNode,
        `${childrenNode.onChange_operation.get_From}#${childrenNode.serviceID.split("#")[2]
        }`,
        matchKey,
        LINES,
        this.props.athenaStorage
      );

      if (
        childrenNode.onChange_operation.operation &&
        childrenNode.onChange_operation.operation === "show_next_dropdown"
      ) {
        console.log("onchange12");
        let child_Name = childrenNode.onChange_operation.child_Name;

        let OPTIONS = [];

        if (LINES?.length) {
          let newSet = [...new Set(LINES?.map((each) => each[child_Name]))];

          newSet.forEach((each) => {
            OPTIONS.push({
              label: each,
              value: each,
            });
          });

          this.changeValBy_row(
            child_Name,
            "serviceKey",
            "options",
            OPTIONS,
            rowNO
          );
          this.props.rerender();
        } else {
          console.log("onchange2");

          this.changeValBy_row(
            child_Name,
            "serviceKey",
            "options",
            OPTIONS,
            rowNO
          );
          this.props.rerender();
        }
      } else {
        if (LINES?.length === 1) {
          let LINE = LINES[0];

          Object.keys(LINE)?.map((one) => {
            console.log("onchange13", LINE, one);
            if (one !== matchKey) {
              let willStore_val = LINE[one];

              console.log(one, "serviceKey", "val", willStore_val, rowNO);
              this.changeValBy_row(
                one,
                "serviceKey",
                "val",
                willStore_val,
                rowNO
              );
              this.props.rerender("noQuit");
            }
          });
        }
      }
    }
  };

  functionToCall = () => {
    // Implement the function logic here
    console.log("Function called from ChildComponent1Child");

    let found;

    let VR2_Form_Json = this.props.VR2_Form_Json;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            if (
              this.state.token === "BillExtract" &&
              each2.title === "Billing Summary"
            ) {
              each2.children.forEach((each3, k) => {
                if (found) return;

                if (each3.children && each3.children?.length) {
                  each3.children.forEach((each4, m) => {
                    if (found) return;
                    if (
                      each4?.render === "true" &&
                      each4.serviceKey === "PO/IP Item Ref" &&
                      each4.type === "select"
                    ) {
                      this.filterPOIPItemRef(each4.serviceID, k, each4);
                    }
                  });
                }
              });
            }
            if (
              this.state.token === "GoodsAndServicesEntries" &&
              each2.title === "Goods & Services Entries Item"
            ) {
              each2.children.forEach((each3, k) => {
                if (found) return;

                if (each3.children && each3.children?.length) {
                  each3.children.forEach((each4, m) => {
                    if (found) return;
                    if (
                      each4?.render === "true" &&
                      each4.serviceKey === "Item Name" &&
                      each4.type === "select"
                    ) {
                      this.filterPOIPItemRef(each4.serviceID, k, each4);
                    }
                  });
                }
              });
            }
          }
        });
      }
    });
  };

  PO_IP_Item_Ref_Pattern_Match = () => {
    let Description = [];

    let found;

    let VR2_Form_Json = this.props.VR2_Form_Json;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            if (
              this.state.token === "BillExtract" &&
              each2.title === "Billing Summary"
            ) {
              each2.children.forEach((each3, k) => {
                if (found) return;

                if (each3.children && each3.children?.length) {
                  each3.children.forEach((each4, m) => {
                    if (found) return;
                    if (
                      each4?.render === "true" &&
                      each4.serviceKey === "Item Name"
                    ) {
                      Description.push(each4.val);
                    }
                  });
                }
              });
            }
          }
        });
      }
    });

    if (Description?.length) {
      let input = {
        Description,
        ORG_ID_CONST: this.props.ORG_ID_CONST,
      };

      postRequest("api/vr2/PO_IP_Item_Ref_Pattern_Match", input).then((res) => {
        // {
        //   "success": "Pattern applied successfully!",
        //   "result": [{
        //     "Description": "ROYAL NATURAL FACIAL TISSUE",
        //     "PatternGroup": "GT-BE1",
        //     "PatternID": "12",
        //     "Item Name": "ROYAL NATURAL FACIAL TISSUE",
        //     "Item ID": "IM0000000001"
        //   }]
        // }
        let reslt = res.res.data;
        VR2_Form_Json?.forEach((each, i) => {
          if (found) return;
          if (each.children && each.children?.length) {
            each.children.forEach((each2, j) => {
              if (found) return;
              if (each2.children && each2.children?.length) {
                if (
                  this.state.token === "BillExtract" &&
                  each2.title === "Billing Summary"
                ) {
                  each2.children.forEach((each3, rowNO) => {
                    if (found) return;

                    if (each3.children && each3.children?.length) {
                      each3.children.forEach((each4, m) => {
                        if (found) return;
                        if (
                          each4?.render === "true" &&
                          each4.serviceKey === "Item Name"
                        ) {
                          reslt.result.forEach((per) => {
                            if (
                              per["Item Name"] &&
                              per["Item ID"] &&
                              each4.val === per["Item Name"]
                            ) {
                              each3.children.forEach((each5, g) => {
                                if (
                                  each5?.render === "true" &&
                                  each5.serviceKey === "PO/IP Item Ref"
                                ) {
                                  each5.options.forEach(async (one_opt) => {
                                    if (
                                      one_opt.value.includes(per["Item ID"])
                                    ) {
                                      each5.val = one_opt.value;

                                      //
                                      // if (each5.onChange_operation) {
                                      //   this.onChange_operation(each5, one_opt.value, rowNO);
                                      // }
                                      // this.onDropDownValueChange({
                                      //   target: {
                                      //       name: each5.serviceKey,
                                      //       id: each5.serviceID,
                                      //       value : one_opt.value
                                      //   }
                                      // })
                                      //
                                    }
                                  });
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              }
            });
          }
        });

        this.props.handleTreeChange(VR2_Form_Json);
        this.props.rerender();
      });
    }
  };

  filterPOIPItemRef = (serviceID, rowNO, childrenNode) => {
    // const serviceID = e.target.id
    let ID;
    let Number;
    let IDonChange;

    let ID_Key;
    let Number_Key;
    let IDonChange_Key;

    if (this.state.token === "BillExtract") {
      ID_Key = "Vendor ID";
      Number_Key = "PO/IP Number";
      IDonChange_Key = "VendorIDonChange";
    }

    if (this.state.token === "GoodsAndServicesEntries") {
      ID_Key = "Sender ID";
      Number_Key = "Order Number";
      IDonChange_Key = "SenderIDonChange";
    }

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, k) => {
              if (found) return;

              if (
                !each3.children &&
                each3?.render &&
                each3?.render === "true" &&
                (each3.serviceKey === ID_Key || each3.serviceKey === Number_Key)
              ) {
                if (each3.serviceKey === ID_Key) {
                  ID = each3.val;
                  IDonChange = each3[IDonChange_Key]
                    ? each3[IDonChange_Key]
                    : null;

                  if (ID && Number) found = true;
                } else if (each3.serviceKey === Number_Key) {
                  Number = each3.val;

                  if (ID && Number) found = true;
                }

                if (found) return;
              }
            });
          }
          if (this.state.token === "BillExtract") {
            if (each2.title === "Billing Summary") {
              if (
                each2.children &&
                each2.children?.length &&
                each2.children[rowNO] &&
                each2.children[rowNO].children
              ) {
                each2.children[rowNO].children.forEach((each4, m) => {
                  if (found) return;

                  if (
                    !each4.children &&
                    each4?.render &&
                    each4?.render === "true" &&
                    (each4.serviceKey === ID_Key ||
                      each4.serviceKey === Number_Key)
                  ) {
                    if (each4.serviceKey === Number_Key) {
                      Number = each4.val;
                      if (ID && Number) found = true;
                    }

                    if (found) return;
                  }
                });
              }
            }
          }
        });
      }
    });

    // if( (!IDonChange || (IDonChange && IDonChange === "true") )  && ID?.length && !Number?.length){
    if (ID !== undefined && Number !== undefined && IDonChange !== undefined) {
      // if( (!IDonChange || (IDonChange && !IDonChange.includes(serviceID)) )  && ID?.length && !Number?.length){

      //   let ok = <Popup
      //             handleClose={() => this.setState({filterPOIPItemRef: null})}
      //             content={
      //             <>

      //               <div className="mt-3 mb-3" align="center">
      //                 <div>
      //                   Do you want to filter the options based on {ID_Key} ?
      //                 </div>
      //               </div>

      //               <div align="center">
      //                 <button onClick={() => this.filterPOIPItemRef_yes("")} className="btn btn-secondary btn-sm">No</button>
      //                 <button onClick={() => this.filterPOIPItemRef_yes(ID)} className="btn btn-success btn-sm ml-1">Yes</button>
      //               </div>

      //             </>
      //             }
      //           />

      //   this.setState({filterPOIPItemRef : ok, ROW_NUM : rowNO})
      //   this.changeValByserviceID_or_Key( ID_Key, "serviceKey", IDonChange_Key, serviceID, "push")

      // }

      if (ID?.length && !Number?.length) {
        this.filterPOIPItemRef_yes(ID, rowNO, childrenNode);
      }
    }
  };

  filterPOIPItemRef_yes = (ID, rowNO, childrenNode) => {
    let POIPItemRef;
    // let rowNO = this.state.ROW_NUM

    let fiter_options_of;
    let ID_Key;

    if (this.state.token === "BillExtract") {
      fiter_options_of = "PO/IP Item Ref";
      ID_Key = "Vendor ID";
    }
    if (this.state.token === "GoodsAndServicesEntries") {
      fiter_options_of = "Item Name";
      ID_Key = "Sender ID";
    }

    let found;

    let VR2_Form_Json = this.props.VR2_Form_Json;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, k) => {
              if (found) return;

              if (each3.children && each3.children?.length) {
                each3.children.forEach((each4, m) => {
                  if (found) return;
                  if (
                    each4?.render === "true" &&
                    each4.serviceKey === fiter_options_of &&
                    each4.type === "select"
                  ) {
                    POIPItemRef = each4;

                    if (ID && POIPItemRef) found = true;

                    if (found) return;
                  }
                });
              }
            });
          }
        });
      }
    });

    let athenaStorage = this.props.athenaStorage;

    if (
      ID &&
      ID?.length &&
      POIPItemRef &&
      athenaStorage[POIPItemRef.dynamic_option.what_to_store] &&
      athenaStorage[POIPItemRef.dynamic_option.what_to_store]?.length
    ) {
      let OPTS = athenaStorage[POIPItemRef.dynamic_option.what_to_store];

      let newOPTS = OPTS.filter((each) => {
        // some times ID may be more than one joined with ", " eg..  "VM0000000197, VM0000000079"

        let V_ID = each[ID_Key] ? each[ID_Key] : "";

        // console.log(ID_Key, V_ID)

        if (V_ID.includes(", ")) {
          V_ID = V_ID.split(", ");
        } else if (V_ID.includes(",")) {
          V_ID = V_ID.split(",");
        }

        if (typeof V_ID === "object") {
          return V_ID.includes(ID);
        } else {
          return V_ID && V_ID === ID;
        }
      });

      console.log(newOPTS);

      let newSet = [...new Set(newOPTS?.map((each) => each[fiter_options_of]))];

      let options = [];

      newSet.forEach((one) => {
        options.push({
          label: one,
          value: one,
        });
      });

      console.log(options);

      if (options?.length === 1) {
        // if option is one fill automatically
        if (this.state.token === "BillExtract") {
          this.changeValBy_sec_row(
            fiter_options_of,
            "serviceKey",
            "options",
            options,
            "Billing Summary",
            rowNO
          );
        }
        if (this.state.token === "GoodsAndServicesEntries") {
          this.changeValByserviceID_or_Key(
            fiter_options_of,
            "serviceKey",
            "options",
            options
          );
        }

        if (!childrenNode.val) {
          if (childrenNode.onChange_operation) {
            this.onChange_operation(childrenNode, options[0].value, rowNO);
          }
          this.onDropDownValueChange({
            target: {
              name: childrenNode.serviceKey,
              id: childrenNode.serviceID,
              value: options[0].value,
            },
          });
        }

        this.props.rerender();

        this.setState({ filterPOIPItemRef: null, ROW_NUM: null });
      } else if (options?.length) {
        if (this.state.token === "BillExtract") {
          // if(!this.PO_IP_Item_Ref_Pattern_Match_Called){

          //     this.PO_IP_Item_Ref_Pattern_Match_Called = true

          //     this.PO_IP_Item_Ref_Pattern_Match()
          // }

          this.changeValBy_sec_row(
            fiter_options_of,
            "serviceKey",
            "options",
            options,
            "Billing Summary",
            rowNO
          );
        }
        if (this.state.token === "GoodsAndServicesEntries") {
          this.changeValByserviceID_or_Key(
            fiter_options_of,
            "serviceKey",
            "options",
            options
          );
        }

        this.props.rerender();

        this.setState({ filterPOIPItemRef: null, ROW_NUM: null });
      } else {
        // let ok = <Popup
        //       // handleClose={() => this.setState({filterPOIPItemRef: null})}
        //       noClose={true}
        //       content={
        //       <>

        //         <div className="mt-3 mb-3" align="center">
        //           <div>
        //             There is no option found based on this "{ID}" ID. Click "Yes" to show all the options
        //           </div>
        //         </div>

        //         <div align="center">
        //           <button onClick={() => this.filterPOIPItemRef_All(POIPItemRef, fiter_options_of)} className="btn btn-success btn-sm ml-1">Yes</button>
        //         </div>

        //       </>

        //       }
        //     />

        // this.setState({filterPOIPItemRef : ok})

        this.filterPOIPItemRef_All(POIPItemRef, fiter_options_of);
      }
    } else if (!ID?.length && POIPItemRef) {
      this.filterPOIPItemRef_All(POIPItemRef, fiter_options_of);
    }
  };

  filterPOIPItemRef_All = (POIPItemRef, fiter_options_of) => {
    console.log(POIPItemRef, fiter_options_of);

    let rowNO = this.state.ROW_NUM;

    let athenaStorage = this.props.athenaStorage;

    let OPTS = athenaStorage[POIPItemRef.dynamic_option.what_to_store];

    console.log(OPTS);

    let newSet = [...new Set(OPTS?.map((each) => each[fiter_options_of]))];

    let options = [];

    newSet.forEach((one) => {
      options.push({
        label: one,
        value: one,
      });
    });

    console.log(options);

    // this.changeValByserviceID_or_Key( fiter_options_of, "serviceKey", "options", options)
    this.changeValBy_sec_row(
      fiter_options_of,
      "serviceKey",
      "options",
      options,
      "Billing Summary",
      rowNO
    );
    this.props.rerender();

    this.setState({ filterPOIPItemRef: null, ROW_NUM: null });
  };

  store_all_vals = () => {
    let VALS = this.props.storeVals;

    this.props.VR2_Form_Json?.forEach((each, i) => {
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (each2.children && each2.children?.length) {
            each2.children.forEach((each3, k) => {
              if (!each3.children && each3?.render === "true") {
                VALS[each3.serviceID] = each3.val;
              }

              if (each3.children && each3.children?.length) {
                each3.children.forEach((each4, m) => {
                  if (each4?.render === "true") {
                    VALS[each4.serviceID] = each4.val;
                  }
                });
              }
            });
          }
        });
      }
    });

    this.props.updateStoreVals(VALS);
  };

  search_Dynamic_Options = async (childrenNode) => {
    this.store_all_vals();

    let obj = {};

    if (childrenNode.api_info.dynamic_query) {
      for (const each of childrenNode.api_info.dynamic_query) {
        if (each.emailid) {
          obj = {
            ...obj,
            [each.getValueFrom || "email"]: this.props?.userData?.USR_Email,
          };
        } else if (each.getValueFrom === "Organization ID") {
          const name = each.getValueFrom;

          await this.Give_Val_By_ServiceKey(name);

          let value =
            this.props.ORG_ID_CONST ||
            this.props.storeVals["organizationinfo#organizationid"] ||
            this.state.Give_Val_By_ServiceKey[name] ||
            "";

          obj = { ...obj, [name]: value };
        } else {
          const name = each.getValueFrom;
          await this.Give_Val_By_ServiceKey(each.getValueFrom);
          obj = {
            ...obj,
            [name]: this.state.Give_Val_By_ServiceKey[each.getValueFrom],
          };
        }
      }
    }

    // BillExtract_POIPNumber_popup
    let hit = `${childrenNode.api_info.api_Directory}`;

    console.log("hitting", obj, hit, childrenNode);
    postRequest(hit, obj).then((res) => {
      if (res.res.status === "success") {
        let DATA =
          res.res.data && res.res.data?.length ? JSON.parse(res.res.data) : [];

        if (childrenNode.api_info.what_to_store) {
          let athenaStorage = this.props.athenaStorage;
          let index = childrenNode.serviceID.split("#")[2];
          athenaStorage[`${childrenNode.api_info.what_to_store}`] = DATA;
          this.props.updateAthenaStorage(athenaStorage);
        }
        console.log(
          DATA,
          DATA.length,
          this.props.athenaStorage,
          `${childrenNode.api_info.what_to_store}`,
          "athena"
        );

        if (DATA?.length) {
          let matchKey = Object.keys(DATA[0]).find(
            (each) => this.trim(each) === this.trim(childrenNode.serviceKey)
          );
          console.log(DATA, matchKey);

          if (matchKey) {
            let newSet = [...new Set(DATA?.map((each) => each[matchKey]))];

            let options = [];

            newSet.forEach((one) => {
              options.push({
                label: one,
                value: one,
              });
            });
            console.log(options);
            if (this.state.AllItemRef.length == 0) {
              this.setState({ ...this.state, AllItemRef: options });
            }
            this.changeValByserviceID(
              childrenNode.serviceID,
              "options",
              options
            );
            console.log(this.state.DialogData, childrenNode.serviceID);

            if (this.state.DialogData.children) {
              this.setState((prev) => ({
                ...prev,
                DialogData: prev.DialogData.children
                  ? {
                    ...prev.DialogData,
                    children: prev.DialogData.children.map((child) =>
                      child.serviceID === childrenNode.serviceID
                        ? { ...child, options: options }
                        : child
                    ),
                  }
                  : prev.DialogData,
              }));
            }
            this.props.rerender();
          }
        }
      }
    });
  };

  popup_select_fn = async (childrenNode) => {
    this.store_all_vals();
    let tenantID = localStorage.getItem("tenant_id");

    const SerKeys =
      childrenNode.type === "popup_select"
        ? tenantID === "TID00002"
          ? ["Vendor ID", "Invoice Ref"]
          : ["Vendor ID", "Vendor GST Number", "GST Number", "Invoice Ref"]
        : childrenNode.type === "popup_select_goods"
          ? ["Order Type", "Sender ID"]
          : [];

    let obj = {};

    // ✅ ensure values are awaited
    for (const key of SerKeys) {
      await this.Give_Val_By_ServiceKey(key);
      obj[key] = this.state.Give_Val_By_ServiceKey[key];
      console.log(key, this.state.Give_Val_By_ServiceKey, "kry");
    }

    obj.ORG_ID_CONST = this.props.ORG_ID_CONST;

    const hit = `${childrenNode.api_info.api_Directory}`;

    console.log("hitting", hit, obj);

    // ✅ correct missing validation
    const missing = Object.values(obj).some(
      (item) => item === "" || item === null || item === undefined
    );
    if (missing) {
      this.props.showAlert(
        `${SerKeys.join(", ")} required — these are not filled`,
        "error"
      );
      return;
    }

    postRequest(hit, obj).then((res) => {
      if (res.res.status === "success") {
        let DATA =
          res.res.data && res.res.data?.length ? JSON.parse(res.res.data) : [];

        if (DATA?.length) {
          if (this.state.token === "BillExtract") {
            const present = DATA.some(
              (element) =>
                element["PO/IP Type"] === "GoodsReceipt" ||
                element["PO/IP Type"] === "ServiceReceipt"
            );

            if (present) {
              DATA = DATA.map((each) => {
                if (
                  each["PO/IP Type"] === "PurchaseOrder" ||
                  each["PO/IP Type"] === "InternalPlan"
                ) {
                  each.disabled = true;
                }
                return each;
              });
            }
          }

          this.setState({
            popup_table: {
              search: "",
              data: DATA,
              filteredData: DATA,
              header: DATA.length ? Object.keys(DATA[0]) : [],
            },
          });
        }
      }
    });
  };
  on_popup_table_search = (e) => {
    const VAL = e.target.value;

    const data = this.state.popup_table.data;

    const filteredData = data.filter((row) =>
      Object.values(row).some(
        (value) =>
          value &&
          value
            .toString()
            .replace(/\s/g, "")
            .toLowerCase()
            .includes(VAL.replace(/\s/g, "").toLowerCase())
      )
    );

    this.setState({
      ...this.state,
      popup_table: {
        ...this.state.popup_table,
        search: VAL,
        filteredData: filteredData,
      },
    });
  };

  tableRow_click = (childrenNode, ROW) => {
    let ROWNUM = this.state.open_popup_select;

    Object.keys(ROW)?.map((one) => {
      let willStore_val = ROW[one];

      if (this.state.DialogData) {
        console.log(one, "serviceKey", "val", willStore_val, ROW);
        this.handleAddRowChanges(willStore_val, one);
        return;
      }
      this.changeValBy_sec_row(
        one,
        "serviceKey",
        "val",
        willStore_val,
        "Billing Summary",
        ROWNUM
      );
    });

    this.setState({ open_popup_select: false, popup_table: false });
    this.props.rerender("noQuit");
  };

  changeValBy_sec_row = (serviceID_or_Key, matchBy, key, val, TITLE, rowNO) => {
    console.log(serviceID_or_Key, matchBy, key, val, TITLE, rowNO, "rowNO");

    let VR2_Form_Json = this.props.VR2_Form_Json;

    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.title === TITLE) {
            if (
              each2.children &&
              each2.children?.length &&
              each2.children[rowNO] &&
              each2.children[rowNO].children
            ) {
              each2.children[rowNO].children.forEach((each4, m) => {
                if (found) return;
                if (
                  each4?.render === "true" &&
                  this.trim(each4[matchBy]) === this.trim(serviceID_or_Key)
                ) {
                  if (
                    (this.state.token === "BillExtract" ||
                      this.state.token === "GoodsAndServicesEntries") &&
                    (each4.serviceKey === "Item ID" ||
                      each4.serviceKey === "ForPrdFrom" ||
                      each4.serviceKey === "ForPrdTo")
                  ) {
                    this.costAllocationMethod(rowNO, each4.serviceKey, val);
                  }

                  each4[key] = val;
                  console.log(each4, "super243");

                  this.props.handleTreeChange(VR2_Form_Json);
                  found = true;
                  if (each4.serviceKey === "Tax Percentage")
                    this.onTaxPerChange(val, rowNO);

                  if (each4.serviceKey === "PO/IP Number")
                    this.PO_IPNumber(each4, rowNO);

                  return;
                }
              });
            }
          }
        });
      }
    });
  };

  PO_IPNumber = (obj, rowNO) => {
    if (obj.type === "popup_select") {
      let Input = {
        PO_IPNumber: obj.val,
        screen: "BillExtract",
      };

      postRequest("api/vr2apicall/PO_IPNumber", Input).then((res) => {
        if (res.res.status === "success") {
          let DATA = JSON.parse(res.res.data);

          console.log(DATA);

          let athenaStorage = this.props.athenaStorage;

          let toStore = obj.serviceID.split("#");

          toStore.splice(1, 1);

          toStore = toStore.join("#");

          athenaStorage[toStore] = DATA; //gv

          this.props.updateAthenaStorage(athenaStorage);

          let newSet =
            [...new Set(DATA?.map((each) => each["PO/IP Item Ref"]))] || [];

          let options = [];

          newSet.forEach((one) => {
            options.push({
              label: one,
              value: one,
            });
          });

          this.changeValBy_sec_row(
            "PO/IP Item Ref",
            "serviceKey",
            "options",
            options,
            "Billing Summary",
            rowNO
          );
          this.props.rerender();
        }
      });
    }
  };

  handleDownload = (Data) => {
    let result = [];

    Data.forEach((each) => {
      let OBJ = {};
      each.children.forEach((obj) => {
        if (obj?.render === "true") {
          OBJ[obj.serviceKey] = globalhelper.sanitizeText(obj.val);
        }
      });
      result.push(OBJ);
    });

    this.setState(
      {
        ...this.state,
        downloadData: result,
      },
      () => {
        this.downloadLink.link.click();
      }
    );
  };

  //mbp
  getLobOptions = () => {
    if (!this.state.companyid) {
      console.log("Skip getLobOptions - companyid missing");
      return;
    }
    let request = {
      company: this.state.companyid,
    };
    console.log("company", request, this.props, "props");

    postRequest("api/edureka/getDistinctLOBs", request)
      .then((res) => {
        const responseLOB = JSON.parse(res.res.data);
        const distinctLOBs = responseLOB?.map((item) => item.lob) || [];

        this.setState(
          {
            Lob: distinctLOBs,
          },
          () => {
            console.log("Updated Lob state: ", this.state.Lob);
          }
        );
      })
      .catch((err) => {
        console.log("Error fetching LOB options: ", err);
      });
  };

  // getTotalvalue = ()=>{
  //   let VR2_Form_Json = this.props.VR2_Form_Json
  //   console.log(VR2_Form_Json,"vr2 form json")
  // }

  handleClose = () => {
    this.setState({ isPopupOpen: false });
  };

  handleEditRow = () => {
    let Source = this.state.DialogData;
    let VR2_Form_Json = this.props.VR2_Form_Json;
    if (this.state.EditRow === Source.serviceID) {
      let found = false;
      VR2_Form_Json?.forEach((each, i) => {
        if (found) return;
        if (each.children && each.children?.length) {
          each.children.forEach((each2, j) => {
            if (found) return;
            if (each2.children && each2.children?.length) {
              each2.children.forEach((each3, m) => {
                if (found) return;
                if (each3?.serviceID === Source.serviceID) {
                  console.log(Source.children, Source);

                  each3.children = [...Source.children];
                  this.props.handleTreeChange(VR2_Form_Json);
                  this.props.rerender("noQuit");
                  found = true;
                  this.setState({
                    ...this.state,
                    DialogData: null,
                    EditRow: null,
                  });
                  return;
                }
              });
            }
          });
        }
      });
    }
  };
  render() {
    const optionsList = this.state.optionsList;
    const ask_reason = this.state.ask_reason;
    const BillExtract_theme_save = this.state.BillExtract_theme_save;

    const popup_table = this.state.popup_table;
    const open_popup_select = this.state.open_popup_select;

    //mbp
    const { isPopupOpen } = this.state;
    const costAllocationMethodOptions = this.state;

    // console.log(this.props,"props")

    if (this.props.tableData) {
      return (
        <div>
          {this.state.filterPOIPItemRef && this.state.filterPOIPItemRef}
          {this.state.pop_up_1 && this.state.pop_up_1}
          {this.state.pop_up_2 && this.state.pop_up_2}

          {this.state.DialogData && (
            <>
              {" "}
              <Dialog
                fullWidth
                maxWidth={"md"}
                open={true}
                onClose={() =>
                  this.setState({ ...this.state, DialogData: null })
                }
              >
                <DialogTitle>Enter Row Fields</DialogTitle>
                <DialogContent>
                  {(this.state.token === "BillExtract" && (
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6}>
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            this.state.EditRow
                              ? this.handleEditRow()
                              : this.tableRowAdd(
                                null,
                                this.state.DialogData,
                                null,
                                true
                              );
                          }}
                          id="AddRow-form"
                        >
                          <Grid container spacing={2}>
                            {this.state.DialogData?.children.map(
                              (each, index) => {
                                if (
                                  each?.render === "true" &&
                                  each?.serviceKey !== "Line ID"
                                ) {
                                  return (
                                    <Grid
                                      item
                                      xs={
                                        this.state.token === "BillExtract"
                                          ? 6
                                          : 12
                                      }
                                      sm={
                                        this.state.token === "BillExtract"
                                          ? 6
                                          : 12
                                      }
                                      key={each.serviceID || index}
                                    >
                                      {each.subtype === "date" ? (
                                        <LocalizationProvider
                                          dateAdapter={AdapterMoment}
                                        >
                                          <DatePicker
                                            label={each.serviceKey}
                                            value={
                                              each.val
                                                ? moment(each.val, "DD-MM-YYYY")
                                                : null
                                            }
                                            inputFormat="DD-MM-YYYY"
                                            minDate={moment()
                                              .subtract(1, "year")
                                              .startOf("year")}
                                            maxDate={moment().endOf("year")}
                                            views={["year", "month", "day"]}
                                            onChange={(newValue) => {
                                              this.handleAddRowChanges(
                                                newValue
                                                  ? moment(newValue).format(
                                                    "DD-MM-YYYY"
                                                  )
                                                  : "",
                                                each.serviceID
                                              );
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                autoFocus={index === 0}
                                                fullWidth
                                                size="small"
                                                {...params}
                                              />
                                            )}
                                          />
                                        </LocalizationProvider>
                                      ) : each.options ||
                                        each.type === "search&select" ||
                                        each.type === "select" ||
                                        each.type === "multiselect" ? (
                                        <>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              m: 1,
                                            }}
                                          >
                                            {(each?.options &&
                                              each?.options.length > 0 && (
                                                <Autocomplete
                                                  size="small"
                                                  fullWidth
                                                  value={
                                                    each?.options?.find(
                                                      (option) =>
                                                        option.label ===
                                                        each.val
                                                    ) || null
                                                  }
                                                  options={each.options || []}
                                                  getOptionLabel={(option) =>
                                                    option?.label || ""
                                                  }
                                                  isOptionEqualToValue={(
                                                    option,
                                                    value
                                                  ) =>
                                                    option?.value === value ||
                                                    null
                                                  }
                                                  onOpen={() => {
                                                    const key = each.serviceKey + "$" + String(index);
                                                    if (
                                                      each.dynamic_option &&
                                                      each.dynamic_option.api_Directory &&
                                                      !this.props.dynamicOption_Done.includes(key)
                                                    ) {
                                                      let dynamicOption_Done = [...this.props.dynamicOption_Done];
                                                      dynamicOption_Done.push(key);
                                                      this.props.updateDynamicOption_Done(dynamicOption_Done);
                                                      this.dynamic_option_fn(each, index);
                                                    }
                                                  }}
                                                  onChange={(e, newValue) => {
                                                    this.handleAddRowChanges(
                                                      newValue?.value ||
                                                      newValue,
                                                      each.serviceID
                                                    );
                                                  }}
                                                  renderInput={(params) => {
                                                    const isLoading = this.state.apiExecution?.[each.serviceKey + "$" + String(index)];
                                                    return (
                                                      <TextField
                                                        autoFocus={index === 0}
                                                        {...params}
                                                        name={each.serviceKey}
                                                        label={each.serviceKey}
                                                        variant="outlined"
                                                        InputProps={{
                                                          ...params.InputProps,
                                                          endAdornment: (
                                                            <React.Fragment>
                                                              {isLoading ? <CircularProgress size={20} /> : null}
                                                              {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                          ),
                                                        }}
                                                      />
                                                    );
                                                  }}
                                                />
                                              )) || (
                                                <TextField
                                                  size="small"
                                                  autoFocus={index === 0}
                                                  required={each.mandatory}
                                                  name={each.serviceKey}
                                                  label={each.serviceKey}
                                                  type="text"
                                                  fullWidth
                                                  disabled={
                                                    each.editable === "false" ||
                                                    each.type === "search&select"
                                                  }
                                                  value={each.val || ""}
                                                  onChange={(e) => {
                                                    this.handleAddRowChanges(
                                                      e.target.value,
                                                      each.serviceID
                                                    );
                                                  }}
                                                  variant="outlined"
                                                  InputProps={{
                                                    endAdornment: this.state.apiExecution?.[each.serviceKey + "$" + String(index)] ? (
                                                      <InputAdornment position="end">
                                                        <CircularProgress size={20} />
                                                      </InputAdornment>
                                                    ) : null,
                                                  }}
                                                />
                                              )}
                                            {each.type === "search&select" ? (
                                              <IconButton
                                                edge="end"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  this.search_Dynamic_Options(
                                                    each
                                                  );
                                                }}
                                              >
                                                <SearchIcon />
                                              </IconButton>
                                            ) : (
                                              ""
                                            )}
                                          </Box>
                                        </>
                                      ) : (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            m: 1,
                                          }}
                                        >
                                          <TextField
                                            size="small"
                                            autoFocus={index === 0}
                                            required={each.mandatory}
                                            name={each.serviceKey}
                                            label={each.serviceKey}
                                            type="text"
                                            fullWidth
                                            disabled={
                                              each.editable === "false" ||
                                              each.type === "popup_select"
                                            }
                                            value={each.val || ""}
                                            onChange={(e) => {
                                              this.handleAddRowChanges(
                                                e.target.value,
                                                each.serviceID
                                              );
                                            }}
                                            variant="outlined"
                                          />
                                          {each.type === "popup_select" && (
                                            <IconButton
                                              edge="end"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                this.popup_select_fn(each);
                                                this.setState({
                                                  open_popup_select:
                                                    this.state.ROWNUM,
                                                });
                                              }}
                                            >
                                              <SearchIcon />
                                            </IconButton>
                                          )}
                                        </Box>
                                      )}
                                    </Grid>
                                  );
                                }
                                return null;
                              }
                            )}
                          </Grid>
                        </form>
                      </Grid>
                      {this.state.token === "BillExtract" && (
                        <Grid item xs={6} sm={6}>
                          {this.props.PDF_Key && (
                            <div
                              style={{
                                padding: "8px",
                                width: "100%",
                                position: "sticky",
                                marginTop: "64px",
                                top: 0,
                              }}
                            >
                              {/* PDF / Image Preview */}
                              <iframe
                                src={
                                  this.props.fileType?.toLowerCase() === "pdf"
                                    ? `data:application/pdf;base64,${this.props.PDF_Key}`
                                    : `data:image/${this.props.fileType};base64,${this.props.PDF_Key}`
                                }
                                title="pdf-viewer"
                                style={{
                                  width: "100%",
                                  height: "70vh",
                                  border: "none",
                                }}
                              />
                            </div>
                          )}
                        </Grid>
                      )}
                    </Grid>
                  )) || (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          this.state.EditRow
                            ? this.handleEditRow()
                            : this.tableRowAdd(
                              null,
                              this.state.DialogData,
                              null,
                              true
                            );
                        }}
                        id="AddRow-form"
                      >
                        <Grid container spacing={2}>
                          {this.state.DialogData?.children.map((each, index) => {
                            if (
                              each?.render === "true" &&
                              each?.serviceKey !== "Line ID"
                            ) {
                              return (
                                <Grid
                                  item
                                  xs={6}
                                  sm={6}
                                  key={each.serviceID || index}
                                >
                                  {each.subtype === "date" ? (
                                    <LocalizationProvider
                                      dateAdapter={AdapterMoment}
                                    >
                                      <DatePicker
                                        label={each.serviceKey}
                                        value={
                                          each.val
                                            ? moment(each.val, "DD-MM-YYYY")
                                            : null
                                        }
                                        inputFormat="DD-MM-YYYY"
                                        minDate={moment()
                                          .subtract(1, "year")
                                          .startOf("year")}
                                        maxDate={moment().endOf("year")}
                                        views={["year", "month", "day"]}
                                        onChange={(newValue) => {
                                          this.handleAddRowChanges(
                                            newValue
                                              ? moment(newValue).format(
                                                "DD-MM-YYYY"
                                              )
                                              : "",
                                            each.serviceID
                                          );
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            autoFocus={index === 0}
                                            fullWidth
                                            size="small"
                                            {...params}
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  ) : each.options ||
                                    each.type === "search&select" ||
                                    each.type === "select" ||
                                    each.type === "multiselect" ? (
                                    <>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          m: 1,
                                        }}
                                      >
                                        {(each?.options &&
                                          each?.options.length > 0 && (
                                            <Autocomplete
                                              size="small"
                                              fullWidth
                                              value={
                                                each?.options?.find(
                                                  (option) =>
                                                    option.label === each.val
                                                ) || null
                                              }
                                              options={each.options || []}
                                              getOptionLabel={(option) =>
                                                option?.label || ""
                                              }
                                              isOptionEqualToValue={(
                                                option,
                                                value
                                              ) =>
                                                option?.value === value || null
                                              }
                                              onOpen={() => {
                                                const key = each.serviceKey + "$" + String(index);
                                                if (
                                                  each.dynamic_option &&
                                                  each.dynamic_option.api_Directory &&
                                                  !this.props.dynamicOption_Done.includes(key)
                                                ) {
                                                  let dynamicOption_Done = [...this.props.dynamicOption_Done];
                                                  dynamicOption_Done.push(key);
                                                  this.props.updateDynamicOption_Done(dynamicOption_Done);
                                                  this.dynamic_option_fn(each, index);
                                                }
                                              }}
                                              onChange={(e, newValue) => {
                                                this.handleAddRowChanges(
                                                  newValue?.value || newValue,
                                                  each.serviceID
                                                );
                                              }}
                                              renderInput={(params) => {
                                                const isLoading = this.state.apiExecution?.[each.serviceKey + "$" + String(index)];
                                                return (
                                                  <TextField
                                                    autoFocus={index === 0}
                                                    {...params}
                                                    name={each.serviceKey}
                                                    label={each.serviceKey}
                                                    variant="outlined"
                                                    InputProps={{
                                                      ...params.InputProps,
                                                      endAdornment: (
                                                        <React.Fragment>
                                                          {isLoading ? <CircularProgress size={20} /> : null}
                                                          {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                      ),
                                                    }}
                                                  />
                                                );
                                              }}
                                            />
                                          )) || (
                                            <TextField
                                              size="small"
                                              autoFocus={index === 0}
                                              required={each.mandatory}
                                              name={each.serviceKey}
                                              label={each.serviceKey}
                                              type="text"
                                              fullWidth
                                              disabled={
                                                each.editable === "false" ||
                                                each.type === "search&select"
                                              }
                                              value={each.val || ""}
                                              onChange={(e) => {
                                                this.handleAddRowChanges(
                                                  e.target.value,
                                                  each.serviceID
                                                );
                                              }}
                                              variant="outlined"
                                              InputProps={{
                                                endAdornment: this.state.apiExecution?.[each.serviceKey + "$" + String(index)] ? (
                                                  <InputAdornment position="end">
                                                    <CircularProgress size={20} />
                                                  </InputAdornment>
                                                ) : null,
                                              }}
                                            />
                                          )}
                                        {each.type === "search&select" ? (
                                          <IconButton
                                            edge="end"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              this.search_Dynamic_Options(each);
                                            }}
                                          >
                                            <SearchIcon />
                                          </IconButton>
                                        ) : (
                                          ""
                                        )}
                                      </Box>
                                    </>
                                  ) : (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        m: 1,
                                      }}
                                    >
                                      <TextField
                                        size="small"
                                        autoFocus={index === 0}
                                        required={each.mandatory}
                                        name={each.serviceKey}
                                        label={each.serviceKey}
                                        type="text"
                                        fullWidth
                                        disabled={
                                          each.editable === "false" ||
                                          each.type === "popup_select"
                                        }
                                        value={each.val || ""}
                                        onChange={(e) => {
                                          this.handleAddRowChanges(
                                            e.target.value,
                                            each.serviceID
                                          );
                                        }}
                                        variant="outlined"
                                      />
                                      {each.type === "popup_select" && (
                                        <IconButton
                                          edge="end"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.popup_select_fn(each);
                                            this.setState({
                                              open_popup_select:
                                                this.state.ROWNUM,
                                            });
                                          }}
                                        >
                                          <SearchIcon />
                                        </IconButton>
                                      )}
                                    </Box>
                                  )}
                                </Grid>
                              );
                            }
                            return null;
                          })}
                        </Grid>
                      </form>
                    )}
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() =>
                      this.setState({ ...this.state, DialogData: null })
                    }
                    variant="contained"
                    color="error"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    form="AddRow-form"
                    variant="contained"
                    color="primary"
                  >
                    Submit
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )}
          {/* mbp */}
          {isPopupOpen && (
            <CostContributionPopup
              mode="dynamic" //mbp
              lobs={this.state.Lob}
              tableName={this.state.lastServiceIDSegment}
              totalValue={
                this.props.storeVals[
                `billingsummary#basevalue#${this.state.lastServiceIDSegment}`
                ]
              }
              preFillValues={this.state.preFillValues}
              handleClose={this.handleClose}
              handleData={(prop) => {
                console.log("data from popup", prop);
                let optiontype = "DYNAMIC";
                let value1 =
                  prop?.map(
                    (item) =>
                      `${item.lob}:${item.amount}(${item.amountPercentage}%)`
                  ) || [];
                let value2 = `${optiontype}(${value1})`;
                console.log(value1);
                this.setState({
                  preFillValues:
                    prop?.map(
                      (item) =>
                        `${item.lob}: ${item.amount}:${item.amountPercentage}`
                    ) || [],
                });
                this.setState({ dynamicValue: value2 }, () => {
                  console.log(this.state.dynamicValue, "dynamic value");
                  this.onDropDownDynamicValueChange();
                });

                this.handleClose();
              }}
            />
          )}

          <Spinner open={this.state.showSpinner} />
          {BillExtract_theme_save && (
            <Popup
              noClose={true}
              content={
                <>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor="KeyWord">Key Word</label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        id="KeyWord"
                        name="KeyWord"
                        value={BillExtract_theme_save.KeyWord}
                        onChange={this.onChange_BillExtract_theme_save}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor="ItemID">Item ID</label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        id="ItemID"
                        name="ItemID"
                        value={BillExtract_theme_save.ItemID}
                        onChange={this.onChange_BillExtract_theme_save}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor="VendorID">Vendor ID (optional)</label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        id="VendorID"
                        name="VendorID"
                        value={BillExtract_theme_save.VendorID}
                        onChange={this.onChange_BillExtract_theme_save}
                      />
                    </div>
                  </div>

                  <div align="center">
                    <button
                      onClick={this.save_BillExtract_theme}
                      className="btn btn-primary"
                      disabled={!BillExtract_theme_save.KeyWord}
                    >
                      Save
                    </button>
                  </div>
                </>
              }
            />
          )}

          {(this.props.tableData.children?.length > 0 &&
            this.props.tableData.children?.map((treenode, index) => {
              if (treenode.type == "section" && treenode.view == "table") {
                let newCode = "";
                return (
                  <>
                    <div key={index} className="table-container">
                      <div className="section-title">
                        {treenode.title}&nbsp;
                        <button
                          className="btn btn-primary"
                          onClick={() => this.handleDownload(treenode.children)}
                        >
                          {" "}
                          <GetAppIcon />{" "}
                        </button>
                        <CSVLink
                          data={this.state.downloadData}
                          filename={`${treenode.title}.csv`}
                          ref={(r) => (this.downloadLink = r)}
                          target="_blank"
                        ></CSVLink>
                      </div>
                      {this.state.token === "CostAllocationMaster" && (
                        <div align="right">
                          <button
                            className="btn btn-success mb-1"
                            onClick={(e) => this.COPYTOBELOW(treenode)}
                          >
                            Copy Plan to Actual
                          </button>
                        </div>
                      )}

                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            {treenode.children[0].children?.map(
                              (childrenNode, index) => {
                                return (
                                  <>
                                    {childrenNode?.render === "true" && (
                                      <th
                                        key={index}
                                        style={
                                          childrenNode.css
                                            ? childrenNode.css
                                            : childrenNode.serviceKey ===
                                              "Line ID"
                                              ? { maxWidth: "3.5rem" }
                                              : {}
                                        }
                                      >
                                        {childrenNode.title}
                                        {childrenNode.mandatory && (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        )}
                                      </th>
                                    )}
                                  </>
                                );
                              }
                            )}
                            {this.props.tableData.processcode === "BT3I" &&
                              (this.state.DocumentStatus === "Rejected" ||
                                this.state.DocumentStatus ===
                                "Not Released") && (
                                <th
                                  style={{
                                    position: "sticky",
                                    left: 0,
                                    right: 0,
                                    zIndex: 1000,
                                  }}
                                >
                                  Action
                                </th>
                              )}
                          </tr>
                        </thead>
                        <tbody>
                          {treenode.children?.map((children__Node, index) => {
                            let ROWNUM = index;
                            let children_Node = children__Node.children;
                            return (
                              <>
                                <tr key={index}>
                                  {children_Node?.map((eachNode, i) => {
                                    let childrenNode = eachNode;

                                    if (childrenNode?.render === "true") {
                                      // console.count("RENDER DYNAMIC OPTION CHECK");
                                      // console.log({
                                      //     serviceKey: childrenNode.serviceKey,
                                      //     queryName: childrenNode?.dynamic_option?.query_Name,
                                      //     optionsLength: childrenNode.options?.length || 0,
                                      //     alreadyDone: this.props.dynamicOption_Done.includes(
                                      //         childrenNode.serviceKey + "$" + String(ROWNUM)
                                      //     )
                                      // });
                                      if (
                                        childrenNode.type === "select" &&
                                        childrenNode.options === undefined &&
                                        !childrenNode.dynamic_option
                                      ) {
                                        this.option_undef(childrenNode);
                                      }
                                      // dynamic API fetch moved to onOpen event of select/autocomplete fields
                                      else if (
                                        childrenNode.options &&
                                        childrenNode.options.length > 0
                                      ) {
                                        // console.log(
                                        //   "SKIPPING DYNAMIC OPTION API - OPTIONS ALREADY PRESENT",
                                        //   childrenNode.serviceKey,
                                        //   childrenNode.options.length, this.props.dynamicOption_Done, this.dynamicLoading
                                        // );
                                      }
                                      // this.setState(prevState => ({
                                      //     dynamicOption: [...prevState.dynamicOption, String(i) + String(index) ]
                                      // }), () => {
                                      //       this.dynamic_option_fn(childrenNode)
                                      //   })


                                      if (
                                        childrenNode.type === "input" &&
                                        childrenNode.subtype === "date" &&
                                        childrenNode.range_fn &&
                                        childrenNode.range_fn ===
                                        "current_date" &&
                                        !childrenNode.val
                                      ) {
                                        this.current_date(childrenNode);
                                      }
                                      if (
                                        childrenNode.type === "input" &&
                                        childrenNode.subtype === "date" &&
                                        childrenNode.range_fn &&
                                        childrenNode.range_fn ===
                                        "yesterday_date" &&
                                        !childrenNode.val
                                      ) {
                                        this.yesterday_date(childrenNode);
                                      }

                                      if (
                                        childrenNode.position === undefined ||
                                        (childrenNode.position !== "header" &&
                                          childrenNode.position !== "footer")
                                      ) {
                                        return (
                                          <Tooltip title={childrenNode.val}>
                                            <td
                                              style={
                                                childrenNode.css
                                                  ? childrenNode.css
                                                  : childrenNode.serviceKey ===
                                                    "Line ID"
                                                    ? { maxWidth: "3.5rem" }
                                                    : {}
                                              }
                                            >
                                              {childrenNode.type === "input" &&
                                                childrenNode.range_fn ===
                                                "ticketing_status" ? (
                                                <div>
                                                  <button
                                                    className="btn btn-danger mr-1"
                                                    style={{
                                                      opacity:
                                                        childrenNode.editable ===
                                                          "false" ||
                                                          childrenNode.val ===
                                                          "Closed"
                                                          ? "0.4"
                                                          : "1",
                                                    }}
                                                    disabled={
                                                      (childrenNode.editable &&
                                                        childrenNode.editable ===
                                                        "false") ||
                                                      childrenNode.val ===
                                                      "Closed"
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        childrenNode.editable ===
                                                        "false" ||
                                                        childrenNode.val ===
                                                        "Closed"
                                                      ) {
                                                        return;
                                                      }
                                                      let ev = {
                                                        target: {
                                                          id: childrenNode.serviceID,
                                                          name: childrenNode.serviceKey,
                                                          value: "Closed",
                                                        },
                                                      };
                                                      this.myChangeHandler(ev);
                                                    }}
                                                  >
                                                    Close
                                                  </button>

                                                  <button
                                                    className="btn btn-success mr-1"
                                                    style={{
                                                      opacity:
                                                        childrenNode.editable ===
                                                          "false" ||
                                                          childrenNode.val ===
                                                          "Open"
                                                          ? "0.4"
                                                          : "1",
                                                    }}
                                                    disabled={
                                                      (childrenNode.editable &&
                                                        childrenNode.editable ===
                                                        "false") ||
                                                      childrenNode.val ===
                                                      "Open"
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        childrenNode.editable ===
                                                        "false" ||
                                                        childrenNode.val ===
                                                        "Open"
                                                      ) {
                                                        return;
                                                      }
                                                      let ev = {
                                                        target: {
                                                          id: childrenNode.serviceID,
                                                          name: childrenNode.serviceKey,
                                                          value: "Open",
                                                        },
                                                      };
                                                      this.myChangeHandler(ev);
                                                    }}
                                                  >
                                                    Re-open
                                                  </button>

                                                  {childrenNode.editable ===
                                                    "false" ? (
                                                    <>
                                                      <p>
                                                        {childrenNode.val
                                                          ? childrenNode.val
                                                          : ""}
                                                      </p>
                                                    </>
                                                  ) : (
                                                    <input
                                                      type={
                                                        childrenNode.subtype
                                                      }
                                                      ref={
                                                        childrenNode.serviceID
                                                      }
                                                      name={
                                                        childrenNode.serviceKey
                                                      }
                                                      id={
                                                        childrenNode.serviceID
                                                      }
                                                      value={
                                                        childrenNode.val
                                                          ? childrenNode.val
                                                          : ""
                                                      }
                                                      disabled
                                                    />
                                                  )}
                                                </div>
                                              ) : childrenNode.type ===
                                                "input" &&
                                                childrenNode.range_fn ===
                                                "activation_status" ? (
                                                <div
                                                  style={{ display: "flex" }}
                                                >
                                                  <button
                                                    className="btn btn-secondary mr-1"
                                                    style={{
                                                      opacity:
                                                        childrenNode.editable ===
                                                          "false" ||
                                                          childrenNode.val ===
                                                          "Waiting For Approval"
                                                          ? "0.4"
                                                          : "1",
                                                    }}
                                                    disabled={
                                                      (childrenNode.editable &&
                                                        childrenNode.editable ===
                                                        "false") ||
                                                      childrenNode.val ===
                                                      "Waiting For Approval"
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        childrenNode.editable ===
                                                        "false" ||
                                                        childrenNode.val ===
                                                        "Waiting For Approval"
                                                      ) {
                                                        return;
                                                      }
                                                      let ev = {
                                                        target: {
                                                          id: childrenNode.serviceID,
                                                          name: childrenNode.serviceKey,
                                                          value:
                                                            "Waiting For Approval",
                                                        },
                                                      };
                                                      this.ifNotReject(
                                                        childrenNode,
                                                        children_Node
                                                      );
                                                      this.myChangeHandler(ev);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>

                                                  <button
                                                    className="btn btn-success mr-1"
                                                    style={{
                                                      opacity:
                                                        childrenNode.editable ===
                                                          "false" ||
                                                          childrenNode.val ===
                                                          "Approved" ||
                                                          childrenNode.val ===
                                                          "Rejected"
                                                          ? "0.4"
                                                          : "1",
                                                    }}
                                                    disabled={
                                                      (childrenNode.editable &&
                                                        childrenNode.editable ===
                                                        "false") ||
                                                      childrenNode.val ===
                                                      "Approved" ||
                                                      childrenNode.val ===
                                                      "Rejected"
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        childrenNode.editable ===
                                                        "false" ||
                                                        childrenNode.val ===
                                                        "Approved" ||
                                                        childrenNode.val ===
                                                        "Rejected"
                                                      ) {
                                                        return;
                                                      }
                                                      let ev = {
                                                        target: {
                                                          id: childrenNode.serviceID,
                                                          name: childrenNode.serviceKey,
                                                          value: "Approved",
                                                        },
                                                      };
                                                      this.props.setRejectorApprovalStatus(
                                                        true
                                                      );
                                                      this.ifNotReject(
                                                        childrenNode,
                                                        children_Node
                                                      );
                                                      this.myChangeHandler(ev);
                                                    }}
                                                  >
                                                    Approve
                                                  </button>

                                                  <button
                                                    className="btn btn-danger mr-1"
                                                    style={{
                                                      opacity:
                                                        childrenNode.editable ===
                                                          "false" ||
                                                          childrenNode.val ===
                                                          "Approved" ||
                                                          childrenNode.val ===
                                                          "Rejected"
                                                          ? "0.4"
                                                          : "1",
                                                    }}
                                                    disabled={
                                                      (childrenNode.editable &&
                                                        childrenNode.editable ===
                                                        "false") ||
                                                      childrenNode.val ===
                                                      "Approved" ||
                                                      childrenNode.val ===
                                                      "Rejected"
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        childrenNode.editable ===
                                                        "false" ||
                                                        childrenNode.val ===
                                                        "Approved" ||
                                                        childrenNode.val ===
                                                        "Rejected"
                                                      ) {
                                                        return;
                                                      }
                                                      let ev = {
                                                        target: {
                                                          id: childrenNode.serviceID,
                                                          name: childrenNode.serviceKey,
                                                          value: "Rejected",
                                                        },
                                                      };

                                                      this.ifReject(
                                                        childrenNode,
                                                        children_Node
                                                      );
                                                      this.myChangeHandler(ev);
                                                    }}
                                                  >
                                                    Reject
                                                  </button>

                                                  {childrenNode.editable ===
                                                    "false" ? (
                                                    <p>
                                                      {childrenNode.val
                                                        ? childrenNode.val
                                                        : ""}
                                                    </p>
                                                  ) : (
                                                    <input
                                                      type={
                                                        childrenNode.subtype
                                                      }
                                                      ref={
                                                        childrenNode.serviceID
                                                      }
                                                      name={
                                                        childrenNode.serviceKey
                                                      }
                                                      id={
                                                        childrenNode.serviceID
                                                      }
                                                      value={
                                                        childrenNode.val
                                                          ? childrenNode.val
                                                          : ""
                                                      }
                                                      disabled
                                                    />
                                                  )}

                                                  {childrenNode.val ===
                                                    "Approved" ? (
                                                    <span
                                                      style={{
                                                        fontSize: "1.5rem",
                                                        color: "green",
                                                      }}
                                                    >
                                                      <AiFillCheckSquare />
                                                    </span>
                                                  ) : childrenNode.val ===
                                                    "Rejected" ? (
                                                    <span
                                                      style={{
                                                        fontSize: "1.5rem",
                                                        color: "red",
                                                      }}
                                                    >
                                                      <AiFillCloseSquare />
                                                    </span>
                                                  ) : childrenNode.val ===
                                                    "Waiting For Approval" ? (
                                                    <span
                                                      style={{
                                                        fontSize: "1.5rem",
                                                        color: "orange",
                                                      }}
                                                    >
                                                      <AiFillClockCircle />
                                                    </span>
                                                  ) : null}

                                                  {ask_reason && (
                                                    <Popup
                                                      noClose={true}
                                                      content={
                                                        <>
                                                          <div className="row">
                                                            <div className="col-lg-4">
                                                              {ask_reason.title}{" "}
                                                              for Rejection:{" "}
                                                              <span
                                                                style={{
                                                                  color: "red",
                                                                }}
                                                              >
                                                                {ask_reason.mandatory ===
                                                                  "true"
                                                                  ? "*"
                                                                  : null}
                                                              </span>{" "}
                                                            </div>
                                                            <textarea
                                                              type={
                                                                ask_reason.subtype
                                                              }
                                                              className="col-lg-4"
                                                              ref={
                                                                ask_reason.serviceID
                                                              }
                                                              name={
                                                                ask_reason.serviceKey
                                                              }
                                                              id={
                                                                ask_reason.serviceID
                                                              }
                                                              value={
                                                                ask_reason.val
                                                                  ? ask_reason.val
                                                                  : ""
                                                              }
                                                              onBlur={
                                                                this.onBlur
                                                              }
                                                              onChange={
                                                                this
                                                                  .myChangeHandler
                                                              }
                                                            />
                                                          </div>

                                                          <div align="center">
                                                            <button
                                                              onClick={() => {
                                                                this.props.setRejectorApprovalStatus(
                                                                  true
                                                                );
                                                                this.setState({
                                                                  ask_reason:
                                                                    null,
                                                                });
                                                              }}
                                                              className="btn btn-primary"
                                                              disabled={
                                                                !ask_reason.val
                                                              }
                                                            >
                                                              Enter
                                                            </button>
                                                          </div>
                                                        </>
                                                      }
                                                    />
                                                  )}
                                                </div>
                                              ) : childrenNode.children ===
                                                undefined &&
                                                childrenNode.type === "input" &&
                                                childrenNode.subtype !==
                                                "null" &&
                                                childrenNode.subtype !==
                                                "date" &&
                                                childrenNode.subtype !==
                                                "radio" &&
                                                childrenNode.subtype !==
                                                "upload" ? (
                                                <div>
                                                  {childrenNode.editable ===
                                                    "false" ? (
                                                    <p>
                                                      {childrenNode.val || ""}
                                                    </p>
                                                  ) : (
                                                    <input
                                                      type={
                                                        childrenNode.subtype
                                                      }
                                                      ref={
                                                        childrenNode.serviceID
                                                      }
                                                      name={
                                                        childrenNode.serviceKey
                                                      }
                                                      id={
                                                        childrenNode.serviceID
                                                      }
                                                      style={
                                                        childrenNode.subtype ===
                                                          "number"
                                                          ? { width: "8rem" }
                                                          : childrenNode.css
                                                            ? {
                                                              ...childrenNode.css,
                                                              width: "15ch",
                                                            }
                                                            : { width: "15ch" }
                                                      }
                                                      value={
                                                        childrenNode.val
                                                          ? childrenNode.val
                                                          : ""
                                                      }
                                                      onBlur={this.onBlur}
                                                      onChange={(
                                                        event,
                                                        val
                                                      ) => {
                                                        if (
                                                          childrenNode.editable ===
                                                          "false"
                                                        ) {
                                                          return;
                                                        }
                                                        this.myChangeHandler(
                                                          event,
                                                          val
                                                        );
                                                      }}
                                                      disabled={
                                                        childrenNode.editable &&
                                                        childrenNode.editable ===
                                                        "false"
                                                      }
                                                    />
                                                  )}
                                                </div>
                                              ) : childrenNode.children ===
                                                undefined &&
                                                childrenNode.type === "input" &&
                                                childrenNode.subtype ===
                                                "date" ? (
                                                <div>
                                                  {childrenNode.editable ===
                                                    "false" ? (
                                                    <p>
                                                      {childrenNode.val
                                                        ? this.date_DD_MM_YYYY_TO_YYYY_MM_DD(
                                                          childrenNode
                                                        )
                                                        : ""}
                                                    </p>
                                                  ) : (
                                                    <input
                                                      type={
                                                        childrenNode.subtype
                                                      }
                                                      ref={
                                                        childrenNode.serviceID
                                                      }
                                                      name={
                                                        childrenNode.serviceKey
                                                      }
                                                      id={
                                                        childrenNode.serviceID
                                                      }
                                                      style={
                                                        childrenNode.css
                                                          ? childrenNode.css
                                                          : {}
                                                      }
                                                      value={
                                                        childrenNode.val && childrenNode.val !== "Unknown"
                                                          ? this.date_DD_MM_YYYY_TO_YYYY_MM_DD(
                                                            childrenNode
                                                          )
                                                          : ""
                                                      }
                                                      onBlur={this.onBlur}
                                                      onChange={(e) => {
                                                        if (
                                                          childrenNode.editable ===
                                                          "false"
                                                        ) {
                                                          return;
                                                        }
                                                        this.myChangeHandler(
                                                          e,
                                                          true
                                                        );
                                                      }}
                                                      disabled={
                                                        childrenNode.editable &&
                                                        childrenNode.editable ===
                                                        "false"
                                                      }
                                                    />
                                                  )}
                                                </div>
                                              ) : childrenNode.children ===
                                                undefined &&
                                                childrenNode.type ===
                                                "textarea" ? (
                                                <div>
                                                  <textarea
                                                    type={childrenNode.subtype}
                                                    ref={childrenNode.serviceID}
                                                    name={
                                                      childrenNode.serviceKey
                                                    }
                                                    id={childrenNode.serviceID}
                                                    style={
                                                      childrenNode.css
                                                        ? childrenNode.css
                                                        : {}
                                                    }
                                                    value={childrenNode.val}
                                                    onBlur={this.onBlur}
                                                    onChange={(event, val) => {
                                                      if (
                                                        childrenNode.editable ===
                                                        "false"
                                                      ) {
                                                        return;
                                                      }
                                                      this.myChangeHandler(
                                                        event,
                                                        val
                                                      );
                                                    }}
                                                    rows="4"
                                                    cols="50"
                                                    disabled={
                                                      childrenNode.editable &&
                                                      childrenNode.editable ===
                                                      "false"
                                                    }
                                                  />
                                                </div>
                                              ) : childrenNode.children ===
                                                undefined &&
                                                childrenNode.type === "input" &&
                                                childrenNode.subtype ===
                                                "radio" ? (
                                                <div>
                                                  <div>
                                                    <div className="row">
                                                      {childrenNode.values &&
                                                        childrenNode.values
                                                          ?.length &&
                                                        childrenNode.values?.map(
                                                          (each, index) => {
                                                            return (
                                                              <>
                                                                {childrenNode.editable ===
                                                                  "false" ? (
                                                                  <p>
                                                                    {each ===
                                                                      childrenNode.val && (
                                                                        <span>
                                                                          {each}
                                                                        </span>
                                                                      )}
                                                                  </p>
                                                                ) : (
                                                                  <div className="col-lg-6">
                                                                    <input
                                                                      type={
                                                                        childrenNode.subtype
                                                                      }
                                                                      name={
                                                                        childrenNode.serviceKey
                                                                      }
                                                                      id={
                                                                        childrenNode.serviceID
                                                                      }
                                                                      value={
                                                                        each
                                                                      }
                                                                      key={each}
                                                                      checked={
                                                                        each ===
                                                                        childrenNode.val
                                                                      }
                                                                      onBlur={
                                                                        this
                                                                          .onBlur
                                                                      }
                                                                      onChange={(
                                                                        event,
                                                                        val
                                                                      ) => {
                                                                        if (
                                                                          childrenNode.editable ===
                                                                          "false"
                                                                        ) {
                                                                          return;
                                                                        }
                                                                        this.myChangeHandler(
                                                                          event,
                                                                          val
                                                                        );
                                                                      }}
                                                                      disabled={
                                                                        childrenNode.editable &&
                                                                        childrenNode.editable ===
                                                                        "false"
                                                                      }
                                                                    />
                                                                    {each}
                                                                  </div>
                                                                )}
                                                              </>
                                                            );
                                                          }
                                                        )}
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : childrenNode.children ===
                                                undefined &&
                                                childrenNode.type ===
                                                "popup_select" ? (
                                                <div>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      m: 1,
                                                    }}
                                                  >
                                                    <Stack
                                                      direction="row"
                                                      spacing={1}
                                                    >
                                                      {!childrenNode.val.includes(
                                                        ","
                                                      ) && (
                                                          <Chip
                                                            label={
                                                              childrenNode.val
                                                            }
                                                          // onClick={handleDocument}
                                                          />
                                                        )}
                                                    </Stack>
                                                    <IconButton
                                                      edge="end"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        this.popup_select_fn(
                                                          childrenNode
                                                        );
                                                        this.setState({
                                                          open_popup_select:
                                                            ROWNUM,
                                                        });
                                                      }}
                                                    >
                                                      <SearchIcon />
                                                    </IconButton>
                                                  </Box>

                                                  {(open_popup_select === 0 ||
                                                    open_popup_select) &&
                                                    popup_table && (
                                                      <Popup
                                                        content={
                                                          <>
                                                            <div className="row m-4">
                                                              <input
                                                                type="text"
                                                                autoFocus
                                                                className="col-lg-6"
                                                                name="search"
                                                                placeholder="search here"
                                                                value={
                                                                  popup_table.search
                                                                }
                                                                onChange={
                                                                  this
                                                                    .on_popup_table_search
                                                                }
                                                              />
                                                            </div>

                                                            <div className="row m-4">
                                                              {!popup_table
                                                                .filteredData
                                                                ?.length ? (
                                                                <div>
                                                                  No match found
                                                                </div>
                                                              ) : (
                                                                <MuiTableContainer component={Paper} style={{ maxHeight: '60vh' }}>
                                                                  <MuiTable stickyHeader size="small">
                                                                    <MuiTableHead>
                                                                      <MuiTableRow>
                                                                        {popup_table.header?.map((each, indx) => {
                                                                          return (
                                                                            <MuiTableCell key={indx} style={{ fontWeight: 'bold' }}>
                                                                              {each}
                                                                            </MuiTableCell>
                                                                          );
                                                                        })}
                                                                      </MuiTableRow>
                                                                    </MuiTableHead>
                                                                    <MuiTableBody>
                                                                      {popup_table.filteredData?.map((each, index) => {
                                                                        return (
                                                                          <MuiTableRow
                                                                            key={index}
                                                                            hover
                                                                            onClick={() => {
                                                                              if (!each.disabled) this.tableRow_click(childrenNode, each);
                                                                            }}
                                                                            style={
                                                                              each.disabled
                                                                                ? { opacity: 0.5, pointerEvents: "none", cursor: 'default' }
                                                                                : { cursor: 'pointer' }
                                                                            }
                                                                          >
                                                                            {popup_table.header?.map((one, indx) => {
                                                                              return (
                                                                                <MuiTableCell key={indx}>
                                                                                  {each[one]}
                                                                                </MuiTableCell>
                                                                              );
                                                                            })}
                                                                          </MuiTableRow>
                                                                        );
                                                                      })}
                                                                    </MuiTableBody>
                                                                  </MuiTable>
                                                                </MuiTableContainer>
                                                              )}
                                                            </div>
                                                          </>
                                                        }
                                                        handleClose={() =>
                                                          this.setState({
                                                            open_popup_select: false,
                                                            popup_table: false,
                                                          })
                                                        }
                                                      />
                                                    )}
                                                </div>
                                              ) : childrenNode.children ===
                                                undefined &&
                                                (childrenNode.type ===
                                                  "select" ||
                                                  childrenNode.type ===
                                                  "search&select") ? (
                                                <div>
                                                  {/* mbp */}
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      m: 1,
                                                    }}
                                                  >
                                                    <Autocomplete
                                                      disablePortal
                                                      id={
                                                        childrenNode.serviceID
                                                      }
                                                      loading={this.state.apiExecution?.[childrenNode.serviceKey + "$" + String(index)] || false}
                                                      onOpen={() => {
                                                        console.log(this.state.apiExecution);

                                                        const ROWNUM = index;
                                                        const key = childrenNode.serviceKey + "$" + String(ROWNUM);
                                                        if (
                                                          childrenNode.dynamic_option &&
                                                          childrenNode.dynamic_option.api_Directory &&
                                                          !this.props.dynamicOption_Done.includes(key)
                                                        ) {
                                                          this.setState(prevState => ({
                                                            apiExecution: {
                                                              ...prevState.apiExecution,
                                                              [key]: true
                                                            }
                                                          }), () => {
                                                            let dynamicOption_Done = [...this.props.dynamicOption_Done];
                                                            if (!dynamicOption_Done.includes(key)) {
                                                              dynamicOption_Done.push(key);
                                                              this.props.updateDynamicOption_Done(dynamicOption_Done);
                                                            }
                                                            Promise.resolve(this.dynamic_option_fn(childrenNode, ROWNUM));
                                                          });
                                                        }
                                                      }}
                                                      options={
                                                        childrenNode.options !==
                                                          undefined &&
                                                          childrenNode.options
                                                            ?.length
                                                          ? childrenNode.options
                                                          : []
                                                      }
                                                      sx={{
                                                        width: 300,
                                                        fontSize: "1rem",
                                                      }}
                                                      isOptionEqualToValue={(option, value) =>
                                                        !value || option?.value === value?.value || option?.value === value || option === value
                                                      }
                                                      value={childrenNode.val}
                                                      disabled={
                                                        childrenNode.editable &&
                                                        childrenNode.editable ===
                                                        "false"
                                                      }
                                                      onChange={(
                                                        event,
                                                        newValue
                                                      ) => {
                                                        if (
                                                          childrenNode.editable ===
                                                          "false" &&
                                                          childrenNode.type !==
                                                          "input"
                                                        ) {
                                                          return;
                                                        }
                                                        // Assuming newValue is the selected value
                                                        if (
                                                          !newValue &&
                                                          !childrenNode.val
                                                        ) {
                                                          console.log("noVal");
                                                        } else {
                                                          if (
                                                            childrenNode.onChange_operation
                                                          ) {
                                                            this.onChange_operation(
                                                              childrenNode,
                                                              newValue
                                                                ? newValue.value
                                                                : "",
                                                              index
                                                            );
                                                          }
                                                          this.onDropDownValueChange(
                                                            {
                                                              target: {
                                                                name: childrenNode.serviceKey,
                                                                id: childrenNode.serviceID,
                                                                value: newValue
                                                                  ? newValue.value
                                                                  : "",
                                                              },
                                                            }
                                                          );
                                                        }
                                                      }}
                                                      renderInput={(params) => {
                                                        const isLoading = this.state.apiExecution?.[childrenNode.serviceKey + "$" + String(index)];
                                                        console.log(this.state.apiExecution, childrenNode.serviceKey + "$" + String(index), isLoading, "isLoading");

                                                        return (
                                                          <TextField
                                                            {...params}
                                                            label={
                                                              childrenNode.serviceKey
                                                            }
                                                            InputProps={{
                                                              ...params.InputProps,
                                                              endAdornment: (
                                                                <React.Fragment>
                                                                  {isLoading ? <CircularProgress size={20} /> : null}
                                                                  {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                              ),
                                                            }}
                                                          />
                                                        );
                                                      }}
                                                    />
                                                    {childrenNode.type ===
                                                      "search&select" ? (
                                                      <IconButton
                                                        edge="end"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          this.search_Dynamic_Options(
                                                            childrenNode
                                                          );
                                                        }}
                                                      >
                                                        <SearchIcon />
                                                      </IconButton>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Box>
                                                </div>
                                              ) : childrenNode.children ===
                                                undefined &&
                                                childrenNode.type === "input" &&
                                                childrenNode.subtype ===
                                                "upload" ? (
                                                <div>
                                                  {childrenNode.editable ===
                                                    "false" ? (
                                                    <p>Upload</p>
                                                  ) : (
                                                    <>
                                                      <input
                                                        type="file"
                                                        accept=".pdf"
                                                        style={{
                                                          display: "none",
                                                        }}
                                                        id={
                                                          childrenNode.serviceID +
                                                          "l"
                                                        }
                                                        name={
                                                          childrenNode.serviceKey
                                                        }
                                                        ref={
                                                          childrenNode.serviceID
                                                        }
                                                        disabled={
                                                          childrenNode.editable &&
                                                          childrenNode.editable ===
                                                          "false"
                                                        }
                                                        onChange={(e) => {
                                                          if (
                                                            childrenNode.editable ===
                                                            "false"
                                                          ) {
                                                            return;
                                                          }
                                                          let event = {
                                                            target: {
                                                              id: childrenNode.serviceID,
                                                              name: childrenNode.serviceKey,
                                                              files:
                                                                e.target.files,
                                                            },
                                                          };

                                                          this.onUpload(
                                                            event,
                                                            childrenNode
                                                          );
                                                        }}
                                                      />
                                                      <label
                                                        htmlFor={
                                                          childrenNode.serviceID +
                                                          "l"
                                                        }
                                                      >
                                                        <Button
                                                          id={
                                                            childrenNode.serviceID
                                                          }
                                                          variant="contained"
                                                          color="primary"
                                                          component="span"
                                                          disabled={
                                                            childrenNode.editable &&
                                                            childrenNode.editable ===
                                                            "false"
                                                          }
                                                        >
                                                          Upload
                                                          <span className="ml-2">
                                                            <ImFolderUpload />
                                                          </span>
                                                        </Button>
                                                      </label>
                                                    </>
                                                  )}

                                                  {this.state.ValidationError[
                                                    `${childrenNode.serviceID}`
                                                  ] && (
                                                      <Typography
                                                        variant="body2"
                                                        color="error"
                                                        sx={{ marginTop: 1 }}
                                                      >
                                                        {
                                                          this.state
                                                            .ValidationError[
                                                          `${childrenNode.serviceID}`
                                                          ]
                                                        }
                                                      </Typography>
                                                    )}

                                                  {childrenNode.val && (
                                                    <button
                                                      className="btn btn-success ml-2"
                                                      onClick={(e) =>
                                                        this.openPDF(
                                                          e,
                                                          childrenNode
                                                        )
                                                      }
                                                    >
                                                      Open
                                                    </button>
                                                  )}

                                                  {childrenNode.val &&
                                                    this.state.popData &&
                                                    this.state.showPopUP &&
                                                    this.state.showPopUP ===
                                                    childrenNode.serviceID ? (
                                                    <Popup
                                                      content={
                                                        <>
                                                          {/* <iframe src={ URL.createObjectURL(this.state[childrenNode.serviceID]) } width="100%" height="500px" /> */}

                                                          <iframe
                                                            src={`data:application/pdf;base64,${this.state.popData}`}
                                                            title="pdf-viewer"
                                                            style={{
                                                              width: "100%",
                                                              height: "500px",
                                                            }}
                                                          />
                                                        </>
                                                      }
                                                      handleClose={() =>
                                                        this.setState({
                                                          showPopUP: null,
                                                        })
                                                      }
                                                    />
                                                  ) : null}
                                                </div>
                                              ) : (
                                                childrenNode.val
                                              )}
                                            </td>
                                          </Tooltip>
                                        );
                                      }
                                    }
                                  })}
                                  {this.props.tableData.processcode ===
                                    "BT3I" &&
                                    this.state.DocumentStatus &&
                                    (this.state.DocumentStatus === "Rejected" ||
                                      this.state.DocumentStatus ===
                                      "Not Released") && (
                                      <td
                                        style={{
                                          backgroundColor: "#ececec",
                                          position: "sticky",
                                          left: 0,
                                          right: 0,
                                          zIndex: 1000,
                                        }}
                                      >
                                        <IconButton
                                          color="primary"
                                          onClick={() => {
                                            this.setState({
                                              ...this.state,
                                              EditRow: children__Node.serviceID,
                                              DialogData: children__Node,
                                              ROWNUM: ROWNUM,
                                            });
                                          }}
                                        >
                                          <Edit />
                                        </IconButton>
                                        <IconButton
                                          color="error"
                                          disabled={children__Node.serviceKey?.endsWith(
                                            "#0001"
                                          )}
                                          onClick={() => {
                                            this.tableRowDelByServiceID(
                                              children_Node,
                                              children__Node
                                            );
                                          }}
                                        >
                                          <Delete />
                                        </IconButton>
                                      </td>
                                    )}
                                </tr>

                                {index === treenode.children?.length - 1 &&
                                  treenode.AddRow &&
                                  treenode.AddRow === "true" && (
                                    <tr>
                                      {index !== 0 && (
                                        <button
                                          className="btn"
                                          style={{ color: "red", padding: "0" }}
                                          onClick={() =>
                                            this.tableRowDel(
                                              children_Node,
                                              children__Node
                                            )
                                          }
                                        >
                                          <IoMdRemoveCircle />
                                        </button>
                                      )}
                                      <button
                                        className="btn"
                                        style={{ color: "green", padding: "0" }}
                                        onClick={() =>
                                          this.tableRowAdd(
                                            children_Node,
                                            children__Node,
                                            ROWNUM
                                          )
                                        }
                                      >
                                        <IoMdAddCircle />
                                      </button>
                                    </tr>
                                  )}
                              </>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </>
                );
              }
            })) ||
            ""}
        </div>
      );
    } else {
      return <div>Loading.....</div>;
    }
  }
}

function mapStateToProps(state) {
  return {
    VR2_Form_Json: state.VR2.VR2_Form_Json,
    changeLogs: state.VR2.changeLogs,
    storeVals: state.VR2.storeVals,
    athenaStorage: state.VR2.athenaStorage,
    dependency_json: state.VR2.dependency_json,
    dynamicOption_Done: state.VR2.dynamicOption_Done,
    ORG_ID_CONST: state.VR2.ORG_ID_CONST,
    PDF_Key: state.VR2.PDF_Key,
    fileType: state.VR2.fileType,
  };
}

export default connect(mapStateToProps, {
  handleTreeChange,
  updateChangeLogs,
  updateStoreVals,
  updateAthenaStorage,
  updateDynamicOption_Done,
  showAlert,
})(MyTable);
